// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

export const en: Record<string, string> = {
  'sidebar.brand': 'OmniPhysics',
  'sidebar.primaryNavigation': 'Quick access',
  'sidebar.recent': 'Recent',
  'settings.archived.title': 'Archived chats',
  'settings.archived.description': 'Archived chats are hidden from your recent list. You can view or restore them here.',
  'settings.archived.search': 'Search archived chats',
  'settings.archived.empty': 'No archived chats',
  'settings.archived.failed': 'The archive operation could not be completed. Please retry.',
  'settings.archived.restore': 'Restore',
  'settings.archived.restoreNamed': 'Restore chat: {title}',
  'settings.archived.restoring': 'Restoring…',
  'settings.archived.loadMore': 'Load more',
  'sidebar.learningSpace': 'Learning Space',
  'nav.sidebar': 'Navigation',
  'nav.workspaces': 'Courses and projects',
  'nav.pinned': 'Pinned',
  'nav.loadFailed': 'Navigation could not be loaded. Retry.',
  'nav.untitled': 'Untitled chat',
  'nav.noWorkspaces': 'No courses or projects',
  'nav.unpin': 'Unpin',
  'nav.searchTitles': 'Search chat titles',
  'nav.searching': 'Searching…',
  'nav.searchFailed': 'Search failed. Please retry.',
  'nav.noResults': 'No matching chats',
  'nav.pin': 'Pin',
  'settings.archived.section': 'Archived',
  'nav.loadMore': 'Load more',
  'sidebar.sessionActions': 'Chat actions: {title}',
  'app.name': '万象 (OmniPhysics)AI',
  'app.maintenance.networkFallbackMessage': 'The service is restarting, please wait...',
  'app.a11y.skipToContent': 'Skip to main content',
  'user.fallbackName': 'User',

  'common.save': 'Save',
  'common.reset': 'Reset',
  'common.back': 'Back',
  'common.refresh': 'Refresh',
  'common.loading': 'Loading...',
  'common.backToChat': 'Back to Chat',
  'common.cancel': 'Cancel',
  'common.error': 'Operation failed, please try again',
  'common.delete': 'Delete',
  'common.language': 'Language',
  'common.pause': 'Pause',
  'common.resume': 'Resume',
  'common.enabled': 'Enabled',
  'common.disabled': 'Disabled',
  'common.available': 'Available',
  'common.unavailable': 'Unavailable',
  'common.none': 'None',
  'common.on': 'On',
  'common.off': 'Off',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.doc': 'Docs',
  'common.prev': 'Previous',
  'common.next': 'Next',
  'language.en': 'English',
  'language.zh': 'Chinese',

  'sidebar.newChat': 'New Chat',
  'sidebar.noConversations': 'No conversations yet',
  'sidebar.newConversation': 'New Conversation',
  'sidebar.search': 'Search conversations',
  'sidebar.noResults': 'No matching results',
  'sidebar.toggle.open': 'Show sidebar',
  'sidebar.toggle.close': 'Hide sidebar',
  'sidebar.rename': 'Rename',
  'sidebar.archive': 'Archive',
  'sidebar.unarchive': 'Unarchive',
  'sidebar.delete': 'Delete',
  'sidebar.deleteConfirm': 'Delete this conversation? This cannot be undone.',
  'sidebar.share': 'Share',
  'sidebar.shareCopied': 'Conversation copied to clipboard',
  'sidebar.showArchived': 'Show archived',
  'sidebar.hideArchived': 'Hide archived',
  'sidebar.archivedSection': 'Archived',
  'sidebar.renamePlaceholder': 'Enter new name...',
  'sidebar.group.today': 'Today',
  'sidebar.group.yesterday': 'Yesterday',
  'sidebar.group.previous7Days': 'Previous 7 Days',
  'sidebar.group.previous30Days': 'Previous 30 Days',
  'sidebar.group.older': 'Older',

  'header.settings': 'Settings',
  'auth.logout': 'Sign out',

  'userMenu.open': 'Open menu',
  'userMenu.settings': 'Settings',
  'userMenu.workflowEditor': 'Workflow Editor',
  'userMenu.theme': 'Theme',
  'userMenu.theme.light': 'Light',
  'userMenu.theme.dark': 'Dark',
  'userMenu.theme.system': 'System',
  'userMenu.adminPanel': 'Admin Panel',
  'userMenu.mastery': 'Mastery Dashboard',
  // B4 mastery dashboard（Phase 2 rollout 批次二）
  'mastery.eyebrow': 'LEARNING PROFILE',
  'mastery.title': 'Mastery Dashboard',
  'mastery.subtitle': 'Your mastery per physics topic, built from knowledge-tracing posteriors and mistake-book review records.',
  'mastery.loading': 'Loading mastery data…',
  'mastery.loadFailed': 'Failed to load mastery data. Please retry later.',
  'mastery.ktSectionTitle': 'Topic Mastery (BKT posteriors)',
  'mastery.ktEmpty': 'No mastery data yet — complete exercises or error reviews to build your profile.',
  'mastery.observations': '{count} observations',
  'mastery.level.beginner': 'Beginner',
  'mastery.level.intermediate': 'Intermediate',
  'mastery.level.advanced': 'Advanced',
  'mastery.errorStatsTitle': 'Error Statistics',
  'mastery.errorCountLabel': 'Total errors',
  'mastery.mostCommonTopicLabel': 'Weakest topic',
  'mastery.reviewAccuracyLabel': 'Review accuracy',
  'mastery.mistakeBookTitle': 'Mistake-Book Reviews',
  'mastery.mistakeBookEmpty': 'No mistake-book review records yet.',
  'mastery.untitledTopic': 'Uncategorized topic',
  'mastery.roundCorrect': 'Correct',
  'mastery.roundIncorrect': 'Incorrect',
  'mastery.yourAnswer': 'Your answer',
  'mastery.referenceAnswer': 'Reference answer',
  'mastery.explanation': 'Explanation',
  // C5 Co-Writer diff（Phase 2 rollout 批次三）
  'cowriter.title': 'Change Review (Co-Writer)',
  'cowriter.noPendingChanges': 'No pending changes — nothing lands until you approve.',
  'cowriter.pendingCount': '{count} pending',
  'cowriter.accept': 'Accept',
  'cowriter.reject': 'Reject',
  'cowriter.before': 'Before',
  'cowriter.after': 'After',
  'cowriter.kind.regenerate': 'Regenerate',
  'cowriter.kind.insert': 'Insert block',
  'cowriter.kind.move': 'Move block',
  'cowriter.kind.retype': 'Change type',
  'userMenu.logout': 'Sign out',

  'admin.sidebar.title': 'Admin Panel',
  'admin.sidebar.dashboard': 'Dashboard',
  'admin.sidebar.users': 'Users',
  'admin.sidebar.usage': 'Usage',
  'admin.sidebar.sessions': 'Sessions',
  'admin.sidebar.system': 'System',
  'admin.sidebar.subscriptions': 'Subscriptions',
  'admin.sidebar.orders': 'Orders',
  'admin.sidebar.plans': 'Plans',
  'admin.sidebar.settings': 'Settings',
  'admin.sidebar.backToApp': 'Back to App',
  'admin.sidebar.enterChat': 'Enter Chat',
  'admin.sidebar.logout': 'Sign out',
  'admin.sidebar.language': 'Language',
  'admin.sidebar.expand': 'Expand',
  'admin.sidebar.collapse': 'Collapse',
  'admin.sidebar.version': 'v{version}',

  'admin.dashboard.title': 'Dashboard',
  'admin.dashboard.subtitle': 'System overview and key metrics',
  'admin.dashboard.kpi.totalUsers': 'Total Users',
  'admin.dashboard.kpi.totalUsers.desc': 'registered accounts',
  'admin.dashboard.kpi.activeUsersToday': 'Active Users (today)',
  'admin.dashboard.kpi.activeUsersToday.desc': 'users with requests today',
  'admin.dashboard.kpi.requestsToday': 'Requests (today)',
  'admin.dashboard.kpi.tokensToday': 'Tokens (today)',
  'admin.dashboard.kpi.totalSessions': 'Total Sessions',
  'admin.dashboard.kpi.errorsToday': 'Errors (today)',
  'admin.dashboard.kpi.activeUsersTotal': 'Active Users (total)',
  'admin.dashboard.kpi.activeUsersTotal.desc': 'enabled accounts',
  'admin.dashboard.kpi.onlineUsersRealtime': 'Online Users (realtime)',
  'admin.dashboard.kpi.totalTokensAllTime': 'Total Tokens (all time)',
  'admin.dashboard.kpi.totalTokensAllTime.desc': 'cumulative consumption',
  'admin.dashboard.kpi.rpm': 'RPM (req/min)',
  'admin.dashboard.kpi.rpm.desc': '5-min average',
  'admin.dashboard.kpi.tpm': 'TPM (tok/min)',
  'admin.dashboard.kpi.tpm.desc': '5-min average',
  'admin.dashboard.kpi.activeSubscriptions': 'Active Subscriptions',
  'admin.dashboard.kpi.totalRevenue': 'Total Revenue',
  'admin.dashboard.kpi.totalOrders': 'Total Orders',
  'admin.dashboard.kpi.paidOrders': 'Paid Orders',
  'admin.dashboard.requestTrend7Days': 'Request Trend (7 Days)',
  'admin.dashboard.serviceHealth': 'Service Health',
  'admin.dashboard.topUsers7Days': 'Top Users (7 days)',
  'admin.dashboard.req': 'req',
  'admin.dashboard.tok': 'tok',
  'admin.dashboard.noUsageData': 'No usage data yet',
  'admin.dashboard.tokens.localSource': 'Local usage logs',
  'admin.common.noData': 'No data available',
  'admin.common.prev': 'Prev',
  'admin.common.next': 'Next',
  'admin.common.pageOf': 'Page {page} of {total}',
  'admin.health.healthy': 'Healthy',
  'admin.health.degraded': 'Degraded',
  'admin.health.unhealthy': 'Unhealthy',
  'admin.health.unknown': 'Unknown',

  'admin.users.title': 'Users',
  'admin.users.subtitle': '{total} total users',
  'admin.users.addUser': 'Add User',
  'admin.users.search.placeholder': 'Search by email or name...',
  'admin.users.table.email': 'Email',
  'admin.users.table.name': 'Name',
  'admin.users.table.role': 'Role',
  'admin.users.table.status': 'Status',
  'admin.users.table.rateLimit': 'Rate Limit',
  'admin.users.table.lastLogin': 'Last Login',
  'admin.users.table.researchPlan': 'Research Plan',
  'admin.users.table.actions': 'Actions',
  'admin.users.role.user': 'user',
  'admin.users.role.admin': 'admin',
  'admin.users.status.active': 'Active',
  'admin.users.status.disabled': 'Disabled',
  'admin.users.default': 'default',
  'admin.users.action.disable': 'Disable',
  'admin.users.action.enable': 'Enable',
  'admin.users.action.resetPassword': 'Reset Password',
  'admin.users.action.delete': 'Delete User',
  'admin.users.deleteProtect.self': 'You cannot delete your own account',
  'admin.users.deleteProtect.lastAdmin': 'You cannot delete the last active admin',
  'admin.users.roleProtect.lastAdmin': 'You cannot demote the last active admin',
  'admin.users.empty': 'No users found',
  'admin.users.toast.userCreated': 'User created',
  'admin.users.toast.createFailed': 'Failed to create user',
  'admin.users.toast.userDisabled': 'User disabled',
  'admin.users.toast.userEnabled': 'User enabled',
  'admin.users.toast.operationFailed': 'Operation failed',
  'admin.users.toast.passwordReset': 'Password reset',
  'admin.users.toast.passwordResetFailed': 'Password reset failed',
  'admin.users.toast.roleUpdated': 'Role updated',
  'admin.users.toast.roleUpdateFailed': 'Role update failed',
  'admin.users.toast.researchPlanUpdated': 'Research plan updated',
  'admin.users.toast.researchPlanUpdateFailed': 'Failed to update research plan',
  'admin.users.toast.userDeleted': 'User deleted',
  'admin.users.toast.userDeleteFailed': 'Failed to delete user',
  'admin.users.researchPlan.ariaLabel': 'Change research plan for {email}',
  'admin.users.researchPlan.placeholder': 'Change plan',
  'admin.users.researchPlan.free': 'Free',
  'admin.users.researchPlan.pro': 'Pro · research enabled',
  'admin.users.researchPlan.max': 'Max · full research',
  'admin.users.action.features': 'Feature permissions',
  'admin.users.features.title': 'Feature Permissions',
  'admin.users.features.description': 'Grant or revoke premium features for {email} (overrides the plan)',
  'admin.users.features.plan': 'Current plan',
  'admin.users.features.planDefault': 'Plan default',
  'admin.users.features.unset': 'Not declared',
  'admin.users.features.overridden.allow': 'Individually allowed',
  'admin.users.features.overridden.deny': 'Individually denied',
  'admin.users.features.effective.on': 'Enabled',
  'admin.users.features.effective.off': 'Disabled',
  'admin.users.features.allow': 'Allow',
  'admin.users.features.deny': 'Deny',
  'admin.users.features.inherit': 'Inherit plan',
  'admin.users.features.adminBypassHint': '(admin role bypasses feature gating)',
  'admin.users.features.loadFailed': 'Failed to load feature permissions',
  'admin.users.features.updated': 'Feature permissions updated',
  'admin.users.features.updateFailed': 'Failed to update feature permissions',
  'admin.users.features.featureLabel.deep_thinking': 'Deep Thinking',
  'admin.users.features.featureLabel.research_workbench': 'Research Workbench',
  'admin.users.features.featureLabel.priority_response': 'Priority Response',
  'admin.users.dialog.create.title': 'Create User',
  'admin.users.dialog.create.email': 'Email',
  'admin.users.dialog.create.name': 'Name',
  'admin.users.dialog.create.password': 'Password (min 8 chars)',
  'admin.users.dialog.create.submit': 'Create',
  'admin.users.dialog.resetPassword.title': 'Reset Password',
  'admin.users.dialog.resetPassword.newPasswordPlaceholder': 'New password (min 8 chars)',
  'admin.users.dialog.resetPassword.submit': 'Reset',
  'admin.users.action.accessLink': 'Judge access link',
  'admin.users.dialog.accessLink.title': 'Generate judge access link',
  'admin.users.dialog.accessLink.description':
    'Issue a passwordless direct-login link for {email}; judges enter the system by opening it',
  'admin.users.dialog.accessLink.ttl': 'Valid for',
  'admin.users.dialog.accessLink.ttl.1d': '1 day',
  'admin.users.dialog.accessLink.ttl.7d': '7 days (recommended)',
  'admin.users.dialog.accessLink.ttl.30d': '30 days',
  'admin.users.dialog.accessLink.ttl.90d': '90 days',
  'admin.users.dialog.accessLink.ttl.180d': '180 days (half a year)',
  'admin.users.dialog.accessLink.ttl.365d': '365 days (one year)',
  'admin.users.dialog.accessLink.generatedUrl':
    'Access link (copy it for judges, or turn it into a QR code)',
  'admin.users.dialog.accessLink.copy': 'Copy',
  'admin.users.dialog.accessLink.hint':
    'The link contains no account or password; it expires automatically and can be revoked here anytime.',
  'admin.users.dialog.accessLink.generate': 'Generate link',
  'admin.users.dialog.accessLink.revoke': 'Revoke link',
  'admin.users.toast.accessLinkCreated': 'Link generated',
  'admin.users.toast.accessLinkCreateFailed': 'Failed to generate link',
  'admin.users.toast.accessLinkCopied': 'Link copied to clipboard',
  'admin.users.toast.accessLinkCopyFailed': 'Copy failed, please copy manually',
  'admin.users.toast.accessLinkRevoked': 'Link revoked',
  'admin.users.toast.accessLinkRevokeFailed': 'Revoke failed (link may already be expired)',
  'admin.users.dialog.delete.title': 'Confirm User Deletion',
  'admin.users.dialog.delete.description': 'You are about to delete: {email}',
  'admin.users.dialog.delete.warning': 'This action cannot be undone.',
  'admin.users.dialog.delete.submit': 'Delete',
  'admin.users.batch.toolbar.countSelected': '{count} selected',
  'admin.users.batch.toolbar.clearSelection': 'Clear selection',
  'admin.users.batch.toolbar.selectAll': 'Select all',
  'admin.users.batch.toolbar.bulkCreate': 'Bulk add',
  'admin.users.batch.action.enable': 'Enable',
  'admin.users.batch.action.disable': 'Disable',
  'admin.users.batch.action.setRole': 'Set role',
  'admin.users.batch.action.delete': 'Delete',
  'admin.users.batch.action.resetPassword': 'Reset password',
  'admin.users.batch.protect.selfInBatch': 'A batch cannot include your own account',
  'admin.users.batch.protect.lastAdminInBatch': 'The batch would affect the last active admin',
  'admin.users.batch.toast.batchUpdated': 'Batch update succeeded ({count} users)',
  'admin.users.batch.toast.batchUpdateFailed': 'Batch update failed',
  'admin.users.batch.toast.batchDeleted': 'Batch delete succeeded ({count} users)',
  'admin.users.batch.toast.batchDeleteFailed': 'Batch delete failed',
  'admin.users.batch.toast.batchPasswordReset': 'Batch password reset succeeded ({count} users)',
  'admin.users.batch.toast.batchPasswordResetFailed': 'Batch password reset failed',
  'admin.users.batch.toast.batchCreated': 'Bulk create succeeded ({count} users)',
  'admin.users.batch.toast.batchCreateFailed': 'Bulk create failed',
  'admin.users.batch.dialog.batchDelete.title': 'Confirm batch deletion',
  'admin.users.batch.dialog.batchDelete.description': 'You are about to permanently delete {count} users.',
  'admin.users.batch.dialog.batchDelete.warning': 'This action cannot be undone and will cascade-delete each user’s threads, usage logs, and related data.',
  'admin.users.batch.dialog.batchDelete.submit': 'Delete',
  'admin.users.batch.dialog.batchResetPassword.title': 'Batch reset password',
  'admin.users.batch.dialog.batchResetPassword.description': 'A single temporary password will be set for {count} users.',
  'admin.users.batch.dialog.batchResetPassword.newPasswordPlaceholder': 'New password (min 8 chars)',
  'admin.users.batch.dialog.batchResetPassword.submit': 'Reset',
  'admin.users.batch.dialog.batchUpdate.title': 'Batch set role',
  'admin.users.batch.dialog.batchUpdate.description': 'Set the role of the {count} selected users to:',
  'admin.users.batch.dialog.bulkCreate.title': 'Bulk add users',
  'admin.users.batch.dialog.bulkCreate.hint': 'One user per line, format: email,name,password (password min 8 chars)',
  'admin.users.batch.dialog.bulkCreate.placeholder': 'alice@example.com,Alice,12345678\nbob@example.com,Bob,87654321',
  'admin.users.batch.dialog.bulkCreate.submit': 'Bulk create',
  'admin.users.batch.dialog.bulkCreate.parseError': 'Line {line} is malformed, expected: email,name,password',

  'admin.usage.title': 'Usage Analytics',
  'admin.usage.subtitle': 'Resource consumption over time',
  'admin.usage.range.today': 'Today',
  'admin.usage.range.7days': '7 days',
  'admin.usage.range.30days': '30 days',
  'admin.usage.requestTrend': 'Request Trend',
  'admin.usage.tokenConsumption': 'Token Consumption',
  'admin.usage.userLeaderboard': 'User Leaderboard',
  'admin.usage.modelDistribution': 'Model Distribution',
  'admin.usage.eventTypeBreakdown': 'Event Type Breakdown',
  'admin.usage.req': 'req',
  'admin.usage.tok': 'tok',
  'admin.usage.tokens': 'tokens',
  'admin.usage.refresh': 'Refresh',
  'admin.usage.summary': 'Summary',
  'admin.usage.summaryRequests': 'Requests',
  'admin.usage.summaryTotalTokens': 'Total Tokens',
  'admin.usage.summaryInputTokens': 'Input Tokens',
  'admin.usage.summaryOutputTokens': 'Output Tokens',
  'admin.usage.summaryCacheRead': 'Cache Read',
  'admin.usage.summaryCacheCreation': 'Cache Creation',
  'admin.usage.summaryCost': 'Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.sessionBreakdown': 'Session Breakdown',
  'admin.usage.modelBreakdown': 'Model Breakdown',
  'admin.usage.colProvider': 'Provider',
  'admin.usage.colRequests': 'Requests',
  'admin.usage.colTotalTokens': 'Total Tokens',
  'admin.usage.colCacheRead': 'Cache Read',
  'admin.usage.colCacheCreation': 'Cache Creation',
  'admin.usage.colCost': 'Cost',
  'admin.usage.colCostStatus': 'Cost Status',
  'admin.usage.colThreadId': 'Thread ID',
  'admin.usage.colRuns': 'Runs',
  'admin.usage.colLastSeen': 'Last Seen',
  'admin.usage.colModel': 'Model',
  'admin.usage.empty': 'No usage data for the selected range.',
  'admin.usage.error': 'Failed to load usage dimensions.',
  'admin.usage.unknown': 'unknown',
  'admin.usage.loading': 'Loading usage data…',
  'admin.usage.csv': 'CSV',
  'admin.usage.exportCsv': 'Export CSV',

  'admin.subscriptions.title': 'Subscriptions & Orders',
  'admin.subscriptions.subtitle': 'Manage user subscriptions and payment orders',
  'admin.subscriptions.tab.subscriptions': 'Subscriptions',
  'admin.subscriptions.tab.orders': 'Orders',
  'admin.subscriptions.filter.all': 'All',
  'admin.subscriptions.filter.active': 'Active',
  'admin.subscriptions.filter.expired': 'Expired',
  'admin.subscriptions.filter.cancelled': 'Cancelled',
  'admin.subscriptions.filter.paid': 'Paid',
  'admin.subscriptions.filter.pending': 'Pending',
  'admin.subscriptions.filter.failed': 'Failed',
  'admin.subscriptions.filter.refunded': 'Refunded',
  'admin.subscriptions.search.subscriptions': 'Search by user ID or plan',
  'admin.subscriptions.search.orders': 'Search by order No., user ID, or plan',
  'admin.subscriptions.col.userId': 'User ID',
  'admin.subscriptions.col.plan': 'Plan',
  'admin.subscriptions.col.status': 'Status',
  'admin.subscriptions.col.periodStart': 'Start Date',
  'admin.subscriptions.col.periodEnd': 'End Date',
  'admin.subscriptions.col.autoRenew': 'Auto Renew',
  'admin.subscriptions.col.orderNo': 'Order No.',
  'admin.subscriptions.col.amount': 'Amount',
  'admin.subscriptions.col.cycle': 'Cycle',
  'admin.subscriptions.col.paymentStatus': 'Payment Status',
  'admin.subscriptions.col.paidAt': 'Paid At',
  'admin.subscriptions.col.actions': 'Actions',
  'admin.subscriptions.action.downgrade': 'Downgrade to Free',
  'admin.subscriptions.action.cancelOrder': 'Cancel Order',
  'admin.subscriptions.action.refundOrder': 'Refund Order',
  'admin.subscriptions.confirm.downgrade': 'Downgrade this user\'s subscription to Free?',
  'admin.subscriptions.confirm.cancelOrder': 'Cancel this pending order?',
  'admin.subscriptions.confirm.refund': 'Refund this order and revert the subscription?',
  'admin.subscriptions.toast.subscriptionDowngraded': 'Subscription downgraded to Free',
  'admin.subscriptions.toast.subscriptionDowngradeFailed': 'Failed to downgrade subscription',
  'admin.subscriptions.toast.orderCancelled': 'Pending order cancelled',
  'admin.subscriptions.toast.orderCancelFailed': 'Failed to cancel order',
  'admin.subscriptions.toast.orderRefunded': 'Paid order refunded',
  'admin.subscriptions.toast.orderRefundFailed': 'Failed to refund order',

  'admin.plans.title': 'Plan Management',
  'admin.plans.subtitle': 'Edit prices, quotas, and activation status for existing plans',
  'admin.plans.col.code': 'Code',
  'admin.plans.col.name': 'Plan',
  'admin.plans.col.actions': 'Actions',
  'admin.plans.field.description': 'Description',
  'admin.plans.field.priceMonthly': 'Monthly Price',
  'admin.plans.field.priceYearly': 'Yearly Price',
  'admin.plans.field.dailyMessages': 'Daily Messages',
  'admin.plans.field.contextLength': 'Context Length',
  'admin.plans.field.knowledgeBases': 'Knowledge Bases',
  'admin.plans.field.fileSize': 'File Size (MB)',
  'admin.plans.field.sortOrder': 'Sort Order',
  'admin.plans.field.isActive': 'Active',
  'admin.plans.action.create': 'Create Plan',
  'admin.plans.action.save': 'Save',
  'admin.plans.dialog.create.title': 'Create Plan',
  'admin.plans.dialog.create.description':
    'Create a new membership plan with baseline pricing and quotas.',
  'admin.plans.dialog.create.code': 'Plan Code',
  'admin.plans.dialog.create.name': 'Plan Name',
  'admin.plans.dialog.create.descriptionLabel': 'Description',
  'admin.plans.dialog.create.priceMonthly': 'Monthly Price',
  'admin.plans.dialog.create.priceYearly': 'Yearly Price',
  'admin.plans.dialog.create.dailyMessages': 'Daily Messages',
  'admin.plans.dialog.create.contextLength': 'Context Length',
  'admin.plans.dialog.create.knowledgeBases': 'Knowledge Bases',
  'admin.plans.dialog.create.fileSize': 'File Size (MB)',
  'admin.plans.dialog.create.sortOrder': 'Sort Order',
  'admin.plans.dialog.create.isActive': 'Activate immediately',
  'admin.plans.dialog.create.isActiveHint':
    'Disabled plans stay in admin management but are hidden from users.',
  'admin.plans.dialog.create.submit': 'Create Plan',
  'admin.plans.toast.created': 'Plan created',
  'admin.plans.toast.createFailed': 'Failed to create plan',
  'admin.plans.toast.updated': 'Plan updated',
  'admin.plans.toast.updateFailed': 'Failed to update plan',

  'admin.sessions.title': 'Sessions',
  'admin.sessions.subtitle': '{total} total sessions',
  'admin.sessions.filter.placeholder': 'Filter by user ID...',
  'admin.sessions.empty': 'No sessions found',
  'admin.sessions.untitled': 'Untitled Session',
  'admin.sessions.user': 'User',
  'admin.sessions.unknown': 'unknown',
  'admin.sessions.total': 'sessions',
  'admin.sessions.msgs': 'msgs',
  'admin.sessions.action.delete': 'Delete session',
  'admin.sessions.loadingMessages': 'Loading messages...',
  'admin.sessions.noMessages': 'No messages',
  'admin.sessions.expandMessage': 'Show full content',
  'admin.sessions.collapseMessage': 'Collapse content',
  'admin.sessions.confirm.deleteSession': 'Delete this session?',
  'admin.sessions.toast.deleted': 'Session deleted',
  'admin.sessions.toast.deleteFailed': 'Failed to delete session',

  'admin.system.title': 'System Health',
  'admin.system.subtitle': 'Service status and infrastructure metrics',
  'admin.system.services': 'Services',
  'admin.system.databasePool': 'Database Pool',
  'admin.system.rateLimits': 'Rate Limits',
  'admin.system.metricsSummary': 'Prometheus Metrics Summary',
  'admin.system.httpMetrics': 'HTTP Metrics',
  'admin.system.chatMetrics': 'Chat Metrics',
  'admin.system.totalRequests': 'Total Requests',
  'admin.system.avgLatency': 'Avg Latency',
  'admin.system.statusDistribution': 'Status Distribution',
  'admin.system.chatRequests': 'Chat Requests',
  'admin.system.totalTokens': 'Total Tokens',
  'admin.system.exceededTotal': 'Exceeded Total',
  'admin.system.totalPublishes': 'Total Publishes',
  'admin.system.agentflowPublish': 'AgentFlow Publish',
  'admin.system.poolUtilization': 'Pool Utilization',
  'admin.system.poolSize': 'Pool Size',
  'admin.system.checkedIn': 'Checked In',
  'admin.system.checkedOut': 'Checked Out',
  'admin.system.rateLimit.section.global': 'Global',
  'admin.system.rateLimit.key.requests_per_minute': 'Requests per minute',
  'admin.system.rateLimit.key.window_seconds': 'Window seconds',
  'admin.system.dbField.status': 'Status',
  'admin.system.dbField.service': 'Service',
  'admin.system.autoRefresh30s': 'Auto 30s',
  'admin.system.byModel': 'By Model',
  'admin.system.websocket': 'WebSocket',
  'admin.system.activeConnections': 'active connections',
  'admin.system.frequencyPanel.title': 'Request Frequency Monitor',
  'admin.system.frequencyPanel.all': 'All',
  'admin.system.frequencyPanel.threshold': '≥{threshold} rpm',
  'admin.system.frequencyPanel.exportCsv': 'Export CSV',
  'admin.system.frequencyPanel.rpm': '{rpm} req/min',
  'admin.system.frequencyPanel.csv.path': 'Path',
  'admin.system.frequencyPanel.csv.deltaRequests': 'Delta Requests',
  'admin.system.frequencyPanel.csv.requestsPerMin': 'Requests/Min',
  'admin.system.frequencyPanel.csv.totalRequests': 'Total Requests',
  'admin.system.frequencyPanel.empty': 'No burst traffic yet, waiting for next sample',

  'admin.settings.title': 'Settings',
  'admin.settings.subtitle': 'Global configuration and audit logs',
  'admin.settings.maintenance.title': 'Maintenance Mode',
  'admin.settings.maintenance.description':
    'When enabled, normal users see a maintenance page and cannot access the system. Admins can still access the dashboard.',
  'admin.settings.maintenance.active': 'Maintenance switch',
  'admin.settings.maintenance.status.enabled': 'Maintenance mode is active',
  'admin.settings.maintenance.status.disabled': 'System is running normally',
  'admin.settings.maintenance.message': 'Maintenance message',
  'admin.settings.maintenance.messagePlaceholder':
    'Enter the message users will see during maintenance…',
  'admin.settings.maintenance.save': 'Save maintenance settings',
  'admin.settings.maintenance.warning':
    'Enabling maintenance mode will block all non-admin users. Make sure you can log in as admin to disable it later.',
  'admin.settings.toast.maintenanceUpdated': 'Maintenance settings updated',
  'admin.settings.toast.maintenanceUpdateFailed': 'Failed to update maintenance settings',
  'admin.settings.commerce.title': 'Commerce Features',
  'admin.settings.commerce.description':
    'When disabled, normal users no longer see subscriptions, payments, usage-upgrade prompts, and related public APIs are blocked. The two switches are independent: this one controls the commercial surface only; plan quota enforcement is governed by the quota switch; identity, permissions, and sandbox runtime limits are unaffected by either.',
  'admin.settings.commerce.enabled': 'Runtime switch',
  'admin.settings.commerce.status.enabled': 'Commerce features are available to normal users',
  'admin.settings.commerce.status.disabled': 'Commerce features are hidden from normal users',
  'admin.settings.commerce.source': 'Current source: {source}',
  'admin.settings.commerce.save': 'Save commerce setting',
  'admin.settings.solverMode.title': 'Solver Mode',
  'admin.settings.solverMode.description':
    'Select the problem-solving strategy for main chat. Changes apply after an automatic graph reload; no restart needed.',
  'admin.settings.solverMode.label': 'Active mode',
  'admin.settings.solverMode.source': 'Current source: {source}',
  'admin.settings.solverMode.save': 'Save solver mode',
  'admin.settings.solverMode.option.legacy': 'Legacy (single-candidate, cheapest)',
  'admin.settings.solverMode.option.b3': 'B3 (multi-sample verify-select)',
  'admin.settings.solverMode.option.b3_cascade':
    'B3 Cascade (difficulty-adaptive: cheap probe, escalate hard problems)',
  'admin.settings.quota.title': 'Quota Enforcement',
  'admin.settings.quota.description':
    'Toggles plan-based quota enforcement without restarting the gateway. When off, authenticated users can use published capabilities normally (no plan lookups); when on while the commercial surface is off, limit messages use non-commercial wording without upgrade inducement.',
  'admin.settings.quota.enabled': 'Runtime switch',
  'admin.settings.quota.status.enabled': 'Enforcement is active',
  'admin.settings.quota.status.disabled': 'Enforcement is paused',
  'admin.settings.quota.source': 'Current source: {source}',
  'admin.settings.quota.source.config_default': 'config default',
  'admin.settings.quota.source.runtime_override': 'runtime override',
  'admin.settings.quota.save': 'Save quota setting',
  'admin.settings.memory.title': 'Memory Storage Limit',
  'admin.settings.memory.description':
    'Control how many explicit memories each user can keep. When the limit is exceeded, the oldest memory is removed automatically.',
  'admin.settings.memory.limit': 'Explicit memory limit',
  'admin.settings.memory.save': 'Save memory limit',
  'admin.settings.memory.source': 'Current source: {source}',
  'admin.settings.auth.title': 'Authentication Methods',
  'admin.settings.auth.description':
    'Control registration, login, verification, and third-party auth entry points by method. Email/password sign-in stays enabled by default, while public registration and third-party auth stay disabled.',
  'admin.settings.auth.source': 'Current source: {source}',
  'admin.settings.auth.note':
    'Even when a switch is enabled, the capability can still remain unavailable until real SMTP, QQ, WeChat, or SMS credentials are configured.',
  'admin.settings.auth.adminEnabled': 'Admin enabled',
  'admin.settings.auth.configured': 'Externally configured',
  'admin.settings.auth.available': 'Finally available',
  'admin.settings.auth.save': 'Save auth methods',
  'admin.settings.auth.methods.emailPassword.title': 'Email/password sign-in',
  'admin.settings.auth.methods.emailPassword.description':
    'Controls the email/password sign-in entry for admins and pre-created test users.',
  'admin.settings.auth.methods.emailRegistration.title': 'Email registration',
  'admin.settings.auth.methods.emailRegistration.description':
    'Controls the public email registration entry without affecting sign-in for existing accounts.',
  'admin.settings.auth.methods.emailVerification.title': 'Email verification',
  'admin.settings.auth.methods.emailVerification.description':
    'Controls email verification flows and whether sign-in requires a verified email.',
  'admin.settings.auth.methods.qq.title': 'QQ sign-in',
  'admin.settings.auth.methods.qq.description': 'Controls the QQ OAuth entry points.',
  'admin.settings.auth.methods.wechat.title': 'WeChat sign-in',
  'admin.settings.auth.methods.wechat.description': 'Controls the WeChat OAuth entry points.',
  'admin.settings.auth.methods.phone.title': 'Phone auth',
  'admin.settings.auth.methods.phone.description':
    'Controls SMS verification, phone binding, and the future phone sign-in flow.',
  'admin.settings.rateLimit.title': 'Global Rate Limiting',
  'admin.settings.rateLimit.requestsPerMinute': 'Requests per minute',
  'admin.settings.rateLimit.windowSeconds': 'Window (seconds)',
  'admin.settings.toast.quotaUpdated': 'Quota setting updated',
  'admin.settings.toast.quotaUpdateFailed': 'Failed to update quota setting',
  'admin.settings.toast.commerceUpdated': 'Commerce setting updated',
  'admin.settings.toast.commerceUpdateFailed': 'Failed to update commerce setting',
  'admin.settings.toast.solverModeUpdated': 'Solver mode updated',
  'admin.settings.toast.solverModeUpdateFailed': 'Failed to update solver mode',
  'admin.settings.toast.memoryUpdated': 'Memory limit updated',
  'admin.settings.toast.memoryUpdateFailed': 'Failed to update memory limit',
  'admin.settings.toast.authMethodsUpdated': 'Authentication methods updated',
  'admin.settings.toast.authMethodsUpdateFailed': 'Failed to update authentication methods',
  'admin.settings.toast.rateLimitUpdated': 'Rate limit updated',
  'admin.settings.toast.rateLimitUpdateFailed': 'Failed to update rate limit',
  'admin.settings.auditLogs.title': 'Audit Logs',
  'admin.settings.auditLogs.time': 'Time',
  'admin.settings.auditLogs.admin': 'Admin',
  'admin.settings.auditLogs.action': 'Action',
  'admin.settings.auditLogs.allActions': 'All actions',
  'admin.settings.auditLogs.target': 'Target',
  'admin.settings.auditLogs.ip': 'IP',
  'admin.settings.auditLogs.details': 'Details',
  'admin.settings.auditLogs.empty': 'No audit logs',
  'admin.settings.auditLogs.exportCsv': 'Export CSV',

  'auth.login.subtitle': 'Sign in to your account',
  'auth.login.email': 'Email',
  'auth.login.password': 'Password',
  'auth.login.signIn': 'Sign In',
  'auth.login.noAccount': "Don't have an account?",
  'auth.login.signUp': 'Sign up',
  'auth.login.demo':
    'Create an account and sign in directly. Email verification is currently optional.',
  'auth.login.registrationSuccess': 'Registration successful. {email} can sign in now.',
  'auth.login.emailPasswordUnavailable':
    'Email/password sign-in is currently disabled. Contact an administrator to enable this authentication method.',
  'auth.login.registerUnavailable':
    'The platform is in closed beta. Please contact an administrator to create an account.',
  'auth.login.loginOnlyDemo':
    'Contact an administrator to get a test account before your first sign-in.',
  'auth.login.phoneComingSoon':
    'The phone sign-in entry is reserved and will become available after SMS is configured and enabled by an administrator.',
  'auth.login.orSocialLogin': 'or sign in with',
  'auth.login.orDivider': 'Or',
  'auth.login.qqLogin': 'Sign in with QQ',
  'auth.login.wechatLogin': 'Sign in with WeChat',

  'auth.register.title': 'Create Account',
  'auth.register.subtitle': 'Join Physics Intelligent Agent',
  'auth.register.name': 'Name',
  'auth.register.namePlaceholder': 'John Doe',
  'auth.register.confirmPassword': 'Confirm Password',
  'auth.register.passwordMismatch': 'Passwords do not match',
  'auth.register.strengthWeak': 'Weak',
  'auth.register.strengthMedium': 'Medium',
  'auth.register.strengthStrong': 'Strong',
  'auth.register.createAccount': 'Create Account',
  'auth.register.emailRegistrationUnavailable':
    'The platform is in closed beta. Self-registration is paused — contact an administrator to create an account.',
  'auth.register.haveAccount': 'Already have an account?',
  'auth.register.signIn': 'Sign in',

  'auth.verify.verifying': 'Verifying your email...',
  'auth.verify.pleaseWait': 'Please wait while we verify your email address.',
  'auth.verify.successTitle': 'Email Verified!',
  'auth.verify.successMessage':
    'Your email has been verified successfully. You can now sign in to your account.',
  'auth.verify.goToLogin': 'Go to Sign In',
  'auth.verify.errorTitle': 'Verification Failed',
  'auth.verify.codeTitle': 'Enter Verification Code',
  'auth.verify.codeSent': "We've sent a 6-digit verification code to your email.",
  'auth.verify.codeSentTo': 'Verification code sent to {{email}}',
  'auth.verify.codeExpired': 'Code is invalid or expired. Please request a new one.',
  'auth.verify.submitCode': 'Verify',
  'auth.verify.noCode': "Didn't receive the code?",
  'auth.verify.resendCode': 'Resend',
  'auth.verify.checkEmailTitle': 'Check Your Email',
  'auth.verify.checkEmailMessage': "We've sent a verification code to your email.",
  'auth.verify.checkEmailMessageWithAddr': "We've sent a verification code to {{email}}.",
  'auth.verify.resendButton': 'Resend Code',
  'auth.verify.resendIn': 'Resend in',
  'auth.verify.resendSuccess': 'Verification code sent! Please check your inbox.',
  'auth.verify.resendError': 'Failed to resend. Please try again later.',
  'auth.verify.backToLogin': 'Back to Sign In',

  'auth.bind.title': 'Bind Phone Number',
  'auth.bind.subtitle': 'For account security, please bind your phone number.',
  'auth.bind.phoneLabel': 'Phone Number',
  'auth.bind.sendCode': 'Send Code',
  'auth.bind.codeSentTo': 'Code sent to {{phone}}',
  'auth.bind.resendIn': 'Resend in',
  'auth.bind.resendCode': 'Resend Code',
  'auth.bind.sendError': 'Failed to send. Please try again later.',
  'auth.bind.verifyError': 'Code is invalid or expired.',
  'auth.bind.successTitle': 'Phone Bound!',
  'auth.bind.successMessage': 'Phone number bound successfully. Redirecting...',

  'auth.forgot.title': 'Forgot Password',
  'auth.forgot.subtitle': 'Enter your registered email and we will send you a password reset link.',
  'auth.forgot.email': 'Email address',
  'auth.forgot.submit': 'Send Reset Link',
  'auth.forgot.successTitle': 'Email Sent',
  'auth.forgot.successMessage':
    'If the email is registered, you will receive a password reset link. Please check your inbox (including spam).',
  'auth.forgot.backToLogin': 'Back to Login',
  'auth.forgot.tooFrequent': 'Too many requests. Please try again later.',

  'auth.reset.title': 'Set New Password',
  'auth.reset.subtitle': 'Please enter your new password.',
  'auth.reset.newPassword': 'New Password',
  'auth.reset.confirmPassword': 'Confirm New Password',
  'auth.reset.submit': 'Reset Password',
  'auth.reset.passwordMismatch': 'Passwords do not match',
  'auth.reset.successTitle': 'Password Reset',
  'auth.reset.successMessage':
    'Your password has been reset. Please log in with your new password.',
  'auth.reset.goToLogin': 'Go to Login',
  'auth.reset.invalidToken': 'Reset link is invalid or expired. Please request a new one.',

  'auth.changePassword.title': 'Change Password',
  'auth.changePassword.oldPassword': 'Current Password',
  'auth.changePassword.newPassword': 'New Password',
  'auth.changePassword.confirmPassword': 'Confirm New Password',
  'auth.changePassword.sendCode': 'Send Verification Code',
  'auth.changePassword.codeSent': 'Verification code sent to your email',
  'auth.changePassword.deliveryHint':
    'Password change codes are sent to your current sign-in email:',
  'auth.changePassword.codeLabel': 'Email Verification Code',
  'auth.changePassword.codeHint': 'Check your email for the 6-digit code',
  'auth.changePassword.resendCode': 'Resend',
  'auth.changePassword.submit': 'Confirm Change',
  'auth.changePassword.success': 'Password changed successfully',
  'auth.changePassword.mismatch': 'Passwords do not match',
  'auth.changePassword.wrongOld': 'Current password is incorrect',

  'auth.login.forgotPassword': 'Forgot password?',
  'errorBoundary.title': 'Something went wrong',
  'errorBoundary.chunkLoadHint':
    'A new version is being loaded. If the page does not refresh automatically, click "Reload Page".',
  'errorBoundary.genericHint':
    'We apologize for the inconvenience. Please try refreshing the page or contact support if the problem persists.',
  'errorBoundary.tryAgain': 'Try Again',
  'errorBoundary.reloadPage': 'Reload Page',
  'auth.placeholder.email': 'name@example.com',
  'auth.layout.login.quote': 'Explore principles of nature and empower every curious mind with AI.',
  'auth.layout.login.author': 'GeWu AI',
  'auth.layout.register.quote':
    'Education is the kindling of a flame, not the filling of a vessel.',
  'auth.layout.register.author': 'Socrates',
  'auth.layout.reset.quote': 'In the middle of difficulty lies opportunity.',
  'auth.layout.reset.author': 'Albert Einstein',
  'auth.layout.forgot.quote': 'The only way to do great work is to love what you do.',
  'auth.layout.forgot.author': 'Steve Jobs',
  'auth.socialCallback.signingIn': 'Signing in...',

  'usage.daily': 'Daily Messages',
  'usage.upgrade': 'View Plans',

  'notFound.subtitle': 'Page Not Found',
  'notFound.desc': "The page you're looking for doesn't exist.",
  'notFound.back': 'Back to Chat',

  'chat.welcomeTitle': 'Welcome to 万象 (OmniPhysics)AI',
  'chat.welcomeSubtitle': 'Start a new conversation or select one from the sidebar',
  'chat.startNewChat': 'Start New Chat',
  'chat.howHelp': 'How can I help you today?',
  'chat.placeholder': 'Ask a physics question, or type / to discover more features',
  'chat.deepThinking': 'Deep Think',
  'chat.deepThinkingDefault': 'Default',
  'chat.deepThinkingTooltip':
    'Enable deep thinking mode for more thorough reasoning. Requires model support (e.g. DeepSeek)',
  'chat.webSearch': 'Web Search',
  'chat.webSearchTooltip':
    'Enable web search — the agent will search online when needed to supplement answers',
  'chat.webSearch.unavailableBadge': 'Not set up',
  'chat.webSearchTooltip.tavily': 'Enable smart search (Tavily)',
  'chat.webSearchTooltip.duckduckgo': 'Enable smart search (DuckDuckGo)',
  'chat.webSearchTooltip.unavailable': 'Web search is not enabled on the backend',
  'chat.attachFile': 'Attach file',
  'chat.send': 'Send',
  'chat.uploadReady': 'Ready',
  'chat.uploading': 'Uploading…',
  'chat.uploadFailedShort': 'Upload failed — remove and retry',
  'chat.uploadFailed': 'Upload failed',
  'chat.dropFilesHere': 'Drop files here',
  'chat.stop': 'Stop generating',
  'diagnostic.title': 'Solution verification issues',
  'chatMessage.you': 'You',
  'chatMessage.copyMessage': 'Copy message',
  'chatMessage.copyCode': 'Copy code',
  'chatMessage.sources': 'Sources:',
  'chatMessage.sourceN': 'Source {n}',
  'chatMessage.selectedSkills': 'Selected Skills',
  'chatMessage.selectedSkillsPlanned': 'Selected Skills (planned, no tool call this turn)',
  'chatMessage.forkedSkills': 'Forked Skills',
  'chatMessage.skill.copilotInteractivePhysics': 'Copilot Interactive Physics',
  'chatMessage.skill.teacherLessonPlanning': 'Teacher Lesson Planning',
  'runtimeLabels.selectedSkillsCard': 'Selected Skills',
  'runtimeLabels.allowedToolsCard': 'Allowed Tools',
  'runtimeLabels.allowedToolsInline': 'Allowed Tools',
  'runtimeLabels.forkTraceTitle': 'Fork Trace',
  'runtimeLabels.topToolPrefix': 'Top',
  'runtimeLabels.output': 'Output',
  'runtimeLabels.error': 'Error',
  'runtimeLabels.step.none': 'No Steps',
  'runtimeLabels.step.plan': 'Plan',
  'runtimeLabels.step.tool': 'Tool',
  'runtimeLabels.step.finalize': 'Finalize',
  'runtimeLabels.step.clarify': 'Clarify',
  'runtimeLabels.step.review': 'Review',
  'runtimeLabels.step.observe': 'Observe',
  'runtimeLabels.step.merge': 'Merge',
  'runtimeLabels.status.completed': 'Completed',
  'runtimeLabels.status.running': 'Running',
  'runtimeLabels.status.pending': 'Pending',
  'runtimeLabels.status.failed': 'Failed',
  'runtimeLabels.status.cancelled': 'Cancelled',
  'runtimeLabels.status.interrupted': 'Interrupted',
  'runtimeLabels.fusionMode.nodePolicyIntersectSkillPolicyAndRuntimeAvailability':
    'Node policy ∩ skill policy ∩ runtime availability',
  'runtimeLabels.compatibility.compatibilityShim': 'Compatibility shim',
  'runtimeLabels.compatibility.compatibilityOutput': 'Compatibility output',
  'runtimeLabels.catalogSource.bundled': 'Bundled',
  'runtimeLabels.catalogSource.local': 'Local',
  'runtimeLabels.catalogSource.localDir': 'Local directory',
  'runtimeLabels.catalogSource.mcp': 'MCP',
  'runtimeLabels.contextMode.fork': 'Fork',
  'runtimeLabels.contextMode.inline': 'Inline',
  'runtimeLabels.capability.toolPolicy': 'Tool Policy',
  'runtimeLabels.capability.mcpServers': 'MCP Servers',
  'runtimeLabels.capability.mcpTools': 'MCP Tools',
  'runtimeLabels.capability.mcpPrompts': 'MCP Prompts',
  'runtimeLabels.capability.mcpResources': 'MCP Resources',
  'runtimeLabels.capability.mcpSkillSources': 'MCP Skill Sources',
  'runtimeLabels.capability.compatibilityBridge': 'Compatibility Bridge',
  'runtimeLabels.capability.preferredField': 'Preferred Field',
  'runtimeLabels.tool.experimentSimulator': 'Experiment Simulator',
  'runtimeLabels.tool.guidedSessionInterrupt': 'Guided Session Interrupt',
  'runtimeLabels.tool.expressionPlot': 'Expression Plot',
  'runtimeLabels.tool.numericMotionAnalyzer': 'Numeric Motion Analyzer',
  'runtimeLabels.tool.desmosExport': 'Desmos Export',
  'runtimeLabels.tool.python': 'Python',
  'runtimeLabels.tool.pythonSandboxInterpreter': 'Python Sandbox Interpreter',
  'chat.example.newton': "Explain Newton's three laws of motion",
  'chat.example.projectile': 'How do I solve projectile motion problems?',
  'chat.example.energy': 'Difference between kinetic and potential energy',
  'chat.example.force': 'Calculate force on an accelerating object',
  'chat.actor.student': 'Student',
  'chat.actor.teacher': 'Teacher',
  'chat.actor.lockHint': 'Cannot switch while a message is sending',
  'chat.actor.switchHint': 'Switching roles starts a new conversation',
  'chat.suggestion.learnConcepts.title': 'Learn Concepts',
  'chat.suggestion.learnConcepts.prompt': "Explain Newton's three laws of motion with examples",
  'chat.suggestion.solveProblems.title': 'Solve Problems',
  'chat.suggestion.solveProblems.prompt':
    'A ball is thrown upward with initial velocity 20 m/s. Calculate the maximum height (ignore air resistance).',
  'chat.suggestion.em.title': 'Electricity & Magnetism',
  'chat.suggestion.em.prompt':
    'What is the difference between electric field and electric potential?',
  'chat.suggestion.mechanics.title': 'Mechanics',
  'chat.suggestion.mechanics.prompt':
    'Explain conservation of angular momentum and give a typical example.',
  'chat.suggestion.modernPhysics.title': 'Modern Physics',
  'chat.suggestion.modernPhysics.prompt': 'Explain the photoelectric effect and what it implies.',
  'chat.suggestion.quantum.title': 'Quantum Physics',
  'chat.suggestion.quantum.prompt':
    "What is Heisenberg's uncertainty principle and what does it mean?",
  'chat.nav.knowledgeBase': 'Knowledge Base',
  'chat.nav.agentWorkflow': 'Agent Workflow',
  'chat.history.loadEarlier': 'Load earlier messages ({count} hidden)',
  'chat.history.windowHint':
    'Showing the most recent {visible} of {total} messages to keep long threads smooth.',
  'chat.emptyHint.branch': "This session's content may live in a historical branch.",
  'chat.emptyHint.missing': 'Failed to load session content: history is missing.',
  'chat.emptyHint.notLoaded': "This session's content has not been loaded yet.",
  'chat.emptyHint.openTimeTravel': 'Open the Time Travel panel',
  'chat.emptyHint.notRecoverable': 'History is not recoverable: the original records of this conversation no longer exist.',
  'chat.emptyHint.reloadHistory': 'Reload session content',
  'chat.scrollToBottom': 'Scroll to bottom',
  'chat.scrollToBottomUnread': '{count} new messages',
  'chat.usage.title': 'Real-time token usage for this run',
  'chat.usage.tokens': 'Tokens',
  'chat.usage.input': 'In',
  'chat.usage.output': 'Out',
  'chat.usage.cacheRead': 'Cache read',
  'chat.usage.cacheCreation': 'Cache creation',
  'chat.usage.source': 'Source',
  'clarification.title': 'Smart Clarification',
  'clarification.sequential.title': 'Step-by-Step Clarification',
  'clarification.recommended': 'Recommended',
  'clarification.other': 'Other',
  'clarification.customPlaceholder': 'Enter custom input...',
  'clarification.submit': 'Confirm & Generate',
  'clarification.submitted': 'Submitted ✓',
  'clarification.historyTitle': 'Clarification Q&A',
  'clarification.historyQuestions': '{count} questions',
  'clarification.historyExpand': 'Expand',
  'clarification.historyCollapse': 'Collapse',
  'clarification.historyAnswer': 'Your answer',
  'clarification.submitting': 'Submitting...',
  'clarification.next': 'Next Question',
  'chatMessage.ragSource': 'RAG Source',
  'chatMessage.sourcePreview': 'Click to view source content',
  'chatMessage.connecting': 'Connecting...',
  'mainChat.busBar.view': 'View',
  'mainChat.busBar.remove': 'Remove',
  'mainChat.clarifyChoice.questionLabel': 'Q',
  'mainChat.clarifyChoice.answerLabel': 'A',
  'chatMessage.thinking.inProgress': 'Thinking',
  'chatMessage.thinking.inProgressWithTime': 'Thinking ({seconds}s)',
  'chatMessage.thinking.generating': 'Generating',
  'chatMessage.thinking.generatingWithTime': 'Generating ({seconds}s)',
  'chatMessage.thinking.completed': 'Thought',
  'chatMessage.thinking.completedWithTime': 'Thought ({seconds}s)',
  'chatMessage.thinking.failed': 'Failed',
  'chatMessage.thinking.tool': 'Tool',
  'chatMessage.thinking.args': 'Args',
  'chatMessage.thinking.result': 'Result',
  'chatMessage.thinking.state': 'State',
  'chatMessage.thinking.reasoning': 'Reasoning',
  'chatMessage.thinking.toolActivity': 'Tool Activity',
  'chatMessage.thinking.stateSnapshot': 'State Snapshot',
  'chatMessage.thinkingAndOrganizing': 'Thinking and organizing your answer…',
  'chat.model.current': 'Current model',
  'chat.model.currentTitle': 'Current model: {model}',
  'chat.model.currentAria': 'Current model {model}',
  'chat.model.unsavedChanges': 'Unsaved changes',
  'chat.researchLauncher': 'Research Workbench',
  'userMenu.pages': 'Pages',
  'userMenu.pages.learningSpace': 'Learning space',
  'userMenu.pages.researchWorkbench': 'Research workbench',
  'userMenu.pages.knowledgeBase': 'Knowledge base',
  'workbench.backToChat': 'Back to main chat',
  'deepAgent.chat.welcome': 'How can I help? Describe a task and I will plan the steps and produce results.',
  'deepAgent.chat.placeholder': 'Type a message… (press / for slash commands)',
  'deepAgent.chat.disclaimer': 'AI-generated content is for reference only. Please verify.',
  'deepAgentInline.collapse': 'Collapse',
  'deepAgentInline.expand': 'Expand',
  'deepAgentInline.close': 'Close inline session',
  'deepAgentInline.endOwnership': 'End DeepAgent',
  'deepAgentInline.openWorkbench': 'Open full workbench',
  'deepAgentInline.owningBadge': 'inline · owning',
  'deepAgentInline.inlineBadge': 'inline session',
  'deepAgentInline.stopRun': 'Stop',
  'deepAgentInline.stopped': 'Stopped',
  'deepAgentInline.pauseStream': 'Pause view',
  'deepAgentInline.resumeStream': 'Resume view',
  'deepAgentInline.pauseHint': 'Pauses the observation view only; the run continues',
  'chatMessage.webSearchStatus.executed_empty': 'Web search returned no results.',
  'chatMessage.webSearchStatus.timeout': 'Web search timed out; no search results were used this turn.',
  'chatMessage.webSearchStatus.failed': 'Web search failed; no search results were used this turn.',
  'chatMessage.webSearchStatus.unavailable': 'Web search unavailable (backend not configured).',
  'chat.toolbar.kb': 'Conversation knowledge base',
  'chat.toolbar.kbDefaultOption': 'Default knowledge base',
  'chat.toolbar.timeTravelLabel': 'Time Travel',
  'chat.toolbar.checkpointsAvailable': '{count} replayable checkpoints',
  'chat.toolbar.timeTravelToggle': 'Toggle Time Travel panel',
  'chat.toolbar.timeTravelDesc': 'Time Travel: view/replay checkpoints of this conversation',
  'chat.model.agentAria': 'Agent model',
  'chat.timeTravel.closeMask': 'Close Time Travel panel mask',

  // G7-H B4: empty-chat suggestion cards (keyed by suggestionSpecs id) + branch suggestions
  'chat.suggestions.continue.title': 'Continue current interaction',
  'chat.suggestions.continue.prompt': 'Continue the current interaction and advance to the next step based on the pending information.',
  'chat.suggestions.vizTune.title': 'Tune parameters',
  'chat.suggestions.vizTune.prompt': 'Please help me adjust the parameters of the current chart or simulation and explain why it changes.',
  'chat.suggestions.vizCompare.title': 'Compare conditions',
  'chat.suggestions.vizCompare.prompt': 'Please compare the physics under different parameter conditions in the current visualization.',
  'chat.suggestions.vizExport.title': 'Export handout figure',
  'chat.suggestions.vizExport.prompt': 'Please generate a figure explanation based on the current visualization, suitable for lecture handouts.',
  'chat.suggestions.student-projectile-plot-manim.title': 'Interactive plot + Manim',
  'chat.suggestions.student-projectile-plot-manim.prompt': 'Generate an interactive projectile-motion demo: initial speed 20 m/s, launch angle 45°, g=9.8 m/s², with adjustable parameter sliders, and keep the Manim "generate animation" entry. Keep text concise; focus on the chart and animation task status.',
  'chat.suggestions.student-photoelectric-plot.title': 'Photoelectric effect chart',
  'chat.suggestions.student-photoelectric-plot.prompt': 'Draw an interactive chart of the maximum kinetic energy Ek versus incident frequency ν in the photoelectric effect, with work function initially 2.3 eV, and let me adjust parameters afterwards. Briefly explain (in Chinese) the physical meaning of the cutoff frequency and the slope.',
  'chat.suggestions.student-socratic-newton.title': 'Socratic guidance',
  'chat.suggestions.student-socratic-newton.prompt': "Don't give me the answer directly. Use Socratic questioning to guide me step by step to understand Newton's second law. Ask one key question at a time and continue only after I answer.",
  'chat.suggestions.student-clarify-review-plan.title': 'Clarify first, then plan',
  'chat.suggestions.student-clarify-review-plan.prompt': "I'm preparing for the college physics final exam, but don't give me a plan right away. First ask me the 3 most critical clarifying questions, then generate a review plan based on my answers.",
  'chat.suggestions.student-python-verified-solver.title': 'Python-verified solving',
  'chat.suggestions.student-python-verified-solver.prompt': 'Solve: a ball is thrown straight up at 20 m/s with g=10 m/s². What is the maximum height? Give the full physics derivation and verify the key numbers with Python.',
  'chat.suggestions.student-pendulum-experiment.title': 'Experiment & simulation',
  'chat.suggestions.student-pendulum-experiment.prompt': 'Design a classroom-demonstrable experiment on the relation between pendulum period and length, plus a PhET simulation suggestion and Phyphox phone-sensor experiment steps.',
  'chat.suggestions.student-error-review-comeback.title': 'Mistake review',
  'chat.suggestions.student-error-review-comeback.prompt': 'I want to review physics problems I got wrong before. Open my mistake book, pick one I recently got wrong, let me redo it first, then compare my answer with the reference and point out my conceptual gaps.',
  'chat.suggestions.student-weakness-drill.title': 'Weakness drill',
  'chat.suggestions.student-weakness-drill.prompt': 'Based on my mastery data, find the 1 physics topic I am weakest at and give me one moderately difficult practice problem. After I answer, give a detailed explanation and follow up with a variant problem to check I truly mastered it.',
  'chat.suggestions.student-concept-map.title': 'Concept map review',
  'chat.suggestions.student-concept-map.prompt': 'Help me map out the knowledge structure of the "work and energy" chapter: list the core concepts, their derivation relations, and draw an interactive concept map. Mark which ones I have already asked about and which are not yet covered.',
  'chat.suggestions.student-exam-strategy.title': 'Exam strategy',
  'chat.suggestions.student-exam-strategy.prompt': 'There is a college physics midterm next week (kinematics, Newton laws, work-energy relations). Help me set review priorities and give 1 typical worked example plus a checklist of common pitfalls for each area.',
  'chat.suggestions.student-real-world-physics.title': 'Physics in daily life',
  'chat.suggestions.student-real-world-physics.prompt': 'I want to know the real-world applications of electromagnetic induction. Pick the one I am most likely to encounter (e.g., wireless charging), explain the physics of why it works simply, and draw a schematic diagram.',
  'chat.suggestions.student-feynman-explain.title': 'Feynman-style output',
  'chat.suggestions.student-feynman-explain.prompt': 'I just learned conservation of momentum. Listen to me explain it in my own words, then point out anything imprecise or wrong like a strict teacher, and finally grade my explanation.',
  'chat.suggestions.teacher-lesson-interview.title': 'Lesson-plan interview',
  'chat.suggestions.teacher-lesson-interview.prompt': 'Design a 40-minute lesson plan for college physics "Newton\u2019s Second Law" with teaching objectives and classroom activities. First interview me to clarify grade level, student profile, objectives, and interaction style.',
  'chat.suggestions.teacher-discussion-review.title': 'Discussion-chain review',
  'chat.suggestions.teacher-discussion-review.prompt': 'Design a 15-minute classroom discussion question chain for "Electromagnetic Induction", generate the deliverable for classroom discussion, and let me approve or revise it after generation.',
  'chat.suggestions.teacher-lab-interview.title': 'Lab-class interview',
  'chat.suggestions.teacher-lab-interview.prompt': 'Design a 90-minute lab class on "Electromagnetic Induction" for college physics. First interview me about equipment, student foundation, data collection, and assessment requirements, then generate the experiment plan.',
  'chat.suggestions.teacher-quiz-generation.title': 'Quiz set generation',
  'chat.suggestions.teacher-quiz-generation.prompt': 'Generate a 5-question quiz on "Work-Energy Relations": 3 multiple-choice + 2 calculation problems with answers and a grading rubric. Difficulty should span basic to advanced, and let me review each question.',
  'chat.suggestions.teacher-misconception-prep.title': 'Misconception prep',
  'chat.suggestions.teacher-misconception-prep.prompt': 'What misconceptions do students typically have about electromagnetic induction? List the 5 most common ones, how to identify them, and a classroom clarification strategy for each.',
  'chat.suggestions.teacher-phyphox-design.title': 'Phone-sensor experiment',
  'chat.suggestions.teacher-phyphox-design.prompt': 'Design an after-class mini experiment using the Phyphox phone sensor on the topic "measuring the acceleration of an elevator". Provide steps, a data-recording table template, and error-analysis key points so students can do it with a phone.',
  'chat.tasks.expand': 'Expand task status sidebar',
  'chat.tasks.title': 'Task status',
  'chat.tasks.collapse': 'Collapse task status sidebar',
  'chat.tasks.retry': 'Retry this task',
  'chatMessage.inlineThink.title': 'Thinking (inline from model)',
  'chatMessage.discussionArtifact': 'Discussion Design',
  'physicsUi.plotMode.expression': 'Expression Plot',
  'physicsUi.plotMode.parametric': 'Parametric Curve',
  'physicsUi.plotMode.sampledSeries': 'Sampled Series',
  'physicsUi.plotMode.table': 'Data Table',
  'physicsUi.plotMode.generic': 'Generic Plot',

  // --- Phase 3 i18n residue closure: physicsUi actions ---
  'physicsUi.action.hideVectors': 'Hide Vectors',
  'physicsUi.action.showVectors': 'Show Vectors',
  'physicsUi.action.exportDesmos': 'Export Desmos',
  'physicsUi.action.openDesmos': 'Open Desmos',
  'physicsUi.action.generateAnimation': 'Generate Animation',
  'physicsUi.action.resetDefaults': 'Reset Defaults',
  'physicsUi.action.openLink': 'Open Link',
  'physicsUi.action.enableParameter': 'Enable {label}',
  'physicsUi.action.disableParameter': 'Disable {label}',

  // --- Phase 3 i18n residue closure: physicsUi animation ---
  'physicsUi.animation.pending': 'Generating animation',
  'physicsUi.animation.open': 'Open Animation',
  'physicsUi.animation.download': 'Download Video',
  'physicsUi.animation.targetDuration': ' · Target {duration}',
  'physicsUi.animation.estimatedDuration': ' · Est. {duration}',
  'physicsUi.animation.actualDuration': 'Duration {duration}',
  'physicsUi.animation.failed': 'Animation generation failed. Fallback to static explanation.',
  'physicsUi.animation.regenerate': 'Regenerate Animation',
  'physicsUi.animation.expired': 'Animation video is only retained during the current conversation. This video has expired. Regenerate if needed.',
  'physicsUi.animation.extraLabel': 'Extra Animation',

  // --- Phase 3 i18n residue closure: physicsUi sections ---
  'physicsUi.section.workflowStatus': 'Workflow Status',
  'physicsUi.section.fullProcess': 'Full Process',
  'physicsUi.section.fullClarification': 'Full Clarification Record',
  'physicsUi.section.fullReview': 'Full Review Record',

  // --- Phase 3 i18n residue closure: physicsUi code ---
  'physicsUi.code.description': 'Code Demo & Results',
  'physicsUi.code.tab.code': 'Code',
  'physicsUi.code.tab.stdout': 'Output',
  'physicsUi.code.tab.images': 'Images',
  'physicsUi.code.noStdout': 'No additional output',
  'physicsUi.code.noImages': 'This code result does not include image assets.',

  'chatMessage.regenerate': 'Regenerate',
  'chatMessage.feedback.helpful': 'Helpful',
  'chatMessage.feedback.notHelpful': 'Not helpful',
  'chatMessage.timestamp.justNow': 'Just now',

  'settings.title': 'Settings',
  'settings.subtitle': 'Manage appearance, service configuration, and account',
  'settings.tabs.language': 'Language',
  'settings.tabs.languageDesc': 'UI locale and localization',
  'settings.tabs.model': 'Model',
  'settings.tabs.modelDesc': 'Binding and routing strategy',
  'settings.tabs.mcp': 'MCP',
  'settings.tabs.mcpDesc': 'MCP runtime configuration',
  'settings.tabs.skills': 'Skills',
  'settings.tabs.skillsDesc': 'Skill routing and priority',
  'settings.tabs.memory': 'Memory',
  'settings.tabs.mastery': 'Learning Mastery',
  'settings.tabs.memoryDesc': 'Manage what AI remembers about you',
  'settings.tabs.masteryDesc': 'Learning profile from knowledge tracing and mistake review',
  'settings.tabs.myTemplates': 'My Templates',
  'settings.tabs.myTemplatesDesc': 'View your generated lesson plans and teaching content',
  'settings.myTemplates.title': 'My Templates',
  'settings.myTemplates.description':
    'Your generated lesson plans, exams, experiment designs, and other teaching content',
  'settings.myTemplates.empty':
    'No templates yet. Generate lesson plans in teacher mode chat and they will be saved here automatically.',
  'settings.myTemplates.state.fallback': 'Degraded artifact',
  'settings.tabs.subscription': 'Subscription',
  'settings.tabs.subscriptionDesc': 'Upgrade your plan for more features',
  'settings.memory.title': 'Personal Memory',
  'settings.memory.description':
    'AI uses these memories to provide personalized answers. You can add, edit, or delete them anytime.',
  'settings.memory.addTitle': 'Add Memory',
  'settings.memory.addPlaceholder':
    "e.g., I'm a 11th grader, I prefer learning physics through formulas...",
  'settings.memory.category': 'Category',
  'settings.memory.category.general': 'General',
  'settings.memory.category.profile': 'Profile',
  'settings.memory.category.preference': 'Learning preference',
  'settings.memory.category.knowledge': 'Knowledge level',
  'settings.memory.category.topic': 'Subject topic',
  'settings.memory.add': 'Add',
  'settings.memory.created': 'Memory added',
  'settings.memory.updated': 'Memory updated',
  'settings.memory.deleted': 'Memory deleted',
  'settings.memory.cleared': 'All memories cleared',
  'settings.memory.clearConfirm':
    'Are you sure you want to clear all memories? This cannot be undone.',
  'settings.memory.clearAll': 'Clear All',
  'settings.memory.userMemories': 'My Memories',
  'settings.memory.autoMemories': 'Auto-extracted Memories',
  'settings.memory.autoDesc':
    "These were automatically learned from your conversations. You can delete ones you don't need.",
  'settings.memory.empty': 'No memories yet. Add some to help AI know you better!',
  'settings.memory.teachingTitle': 'Teaching Memory',
  'settings.memory.teachingDescription':
    'Keep the existing teaching and personalization memory controls available here.',
  'settings.memory.awareness.title': 'Research Awareness System',
  'settings.memory.awareness.description':
    'View research awareness, long-term research memory, short-term working memory, and operator activity from settings. Available to premium users.',
  'settings.memory.awareness.enabled': 'Awareness mode',
  'settings.memory.awareness.enabledDesc':
    'Show the full research-awareness product page inside settings.',
  'settings.memory.awareness.autoRefresh': 'Auto memory',
  'settings.memory.awareness.autoRefreshDesc':
    'Automatically refresh research awareness and operator-console activity.',
  'settings.memory.awareness.refresh': 'Refresh now',
  'settings.memory.awareness.openWorkbench': 'Open research workbench',
  'settings.memory.awareness.collapsed':
    'The research-awareness page is collapsed. Turn Awareness mode back on to view the full experience.',
  'settings.memory.awareness.storageTitle': 'Awareness info',
  'settings.memory.awareness.storageDescription':
    'Current authority sources for the stable personality layer, long-term truth, and short-term working memory.',
  'settings.memory.awareness.storageStable': 'Stable personality layer',
  'settings.memory.awareness.storageLongTerm': 'Long-term research memory',
  'settings.memory.awareness.storageShortTerm': 'Short-term working memory',
  'settings.memory.awareness.overviewTitle': 'Awareness overview',
  'settings.memory.awareness.overviewDescription':
    'Quickly inspect collaboration persona, handbook, user profile, and long-term research-memory distribution.',
  'settings.memory.awareness.longTermTitle': 'Long-term research memory',
  'settings.memory.awareness.activityTitle': 'Evolution activity',
  'settings.memory.awareness.activityDescription':
    'Recent research short-term memory, snapshot reviews, and follow-up activity.',
  'settings.memory.awareness.activityEmpty': 'No research-awareness activity yet.',
  'settings.memory.awareness.trendTitle': 'Memory trend',
  'settings.memory.awareness.trendDescription':
    'Research-awareness activity trend and core stats for the last 7 days.',
  'settings.memory.awareness.metricShortTerm': 'Short-term memory',
  'settings.memory.awareness.metricSnapshots': 'Retained snapshots',
  'settings.memory.awareness.metricFollowUps': 'Follow-ups',
  'settings.memory.awareness.dangerTitle': 'Danger zone',
  'settings.memory.awareness.dangerDescription':
    'Only affects research-workbench short-term memory and recommendation history. Teaching memory stays intact.',
  'settings.memory.awareness.clearRecommendations': 'Clear research recommendations',
  'settings.memory.awareness.clearProjectMemory': 'Clear research short-term memory',
  'settings.memory.awareness.clearOperatorState': 'Clear operator-console state',
  'settings.memory.awareness.refreshed': 'Research awareness refreshed',
  'settings.memory.awareness.export': 'Export awareness bundle',
  'settings.memory.awareness.import': 'Import awareness bundle',
  'settings.memory.awareness.imported': 'Research awareness bundle imported',
  'settings.memory.awareness.clearedRecommendations': 'Research recommendations cleared',
  'settings.memory.awareness.clearedProjectMemory': 'Research short-term memory cleared',
  'settings.memory.awareness.clearedOperatorState': 'Operator-console state cleared',
  'settings.memory.awareness.lockedTitle': 'Research Awareness System (Premium)',
  'settings.memory.awareness.lockedDescription':
    'Your account does not currently include the advanced modeling-writing-research feature set.',
  'settings.memory.awareness.lockedHint':
    'Upgrade to unlock Research Awareness, long-term research memory, operator snapshots, and follow-up views here.',
  'settings.memory.awareness.upgrade': 'Upgrade subscription',
  'settings.memory.awareness.retry': 'Retry access check',
  'settings.appearance.title': 'Appearance',
  'settings.appearance.theme': 'Theme',
  'settings.appearance.current': 'Current: {mode}',
  'settings.general.title': 'General',
  'settings.general.workflowEditor': 'Open Workflow Editor',
  'settings.general.keepLegacy': 'Keep legacy settings',
  'settings.general.keepLegacyDesc': 'Maintain backward compatibility fields and APIs',
  'settings.general.shortcuts': 'Enable shortcuts',
  'settings.general.shortcutsDesc': 'Allow keyboard shortcuts in chat pages',
  'settings.modules.saved': 'Settings saved',
  'settings.confirm.title': 'Confirm save',
  'settings.confirm.general': 'Save general settings and create a new version snapshot?',
  'settings.confirm.language': 'Save language settings and write audit log?',
  'settings.confirm.model': 'Save model settings and write audit log?',
  'settings.confirm.mcp': 'Save MCP settings and write audit log?',
  'settings.confirm.skills': 'Save Skills settings and write audit log?',
  'settings.language.moduleDesc': 'Set the default locale and sync current UI language.',
  'settings.language.defaultLocale': 'Default language',
  'settings.model.moduleDesc': 'Control workflow scan refresh and node binding strategy.',
  'settings.model.autoRefresh': 'Auto refresh workflow scan',
  'settings.model.autoRefreshDesc':
    'Refresh model requirements automatically after workflow changes.',
  'settings.model.bindingStrategy': 'Default binding strategy',
  'settings.model.strategy.taskType': 'By task type (task-type)',
  'settings.model.strategy.nodeId': 'By node ID (node-id)',
  'settings.model.strategy.manual': 'Manual binding',
  'settings.model.configMovedTitle': 'Model provider config has moved',
  'settings.model.configMovedDesc':
    'The legacy external-services model config entry is deprecated. Please manage provider five-tuples in Settings → Model Providers.',
  'settings.model.configMovedAction': 'Open model providers',
  'settings.model.configMovedSecondary': 'Open model panel',
  'settings.mcp.moduleDesc': 'Manage MCP server transport, auth, retries, and scopes.',
  'settings.mcp.add': 'Add MCP server',
  'settings.mcp.serverFallback': 'MCP Server {index}',
  'settings.mcp.reloadCatalog': 'Reload Catalog',
  'settings.mcp.reloadCatalogSuccess': 'MCP catalog reloaded',
  'settings.mcp.reloadCatalogFailed': 'Failed to reload MCP catalog',
  'settings.mcp.serversCount': 'Servers',
  'settings.mcp.toolsCount': 'Tools',
  'settings.mcp.promptsCount': 'Prompts',
  'settings.mcp.resourcesCount': 'Resources',
  'settings.mcp.runtimeCatalog': 'Runtime Catalog',
  'settings.mcp.catalogStatusFallbackOnly': 'Fallback Only',
  'settings.mcp.catalogStatusActive': 'MCP Active',
  'settings.mcp.localServer': 'Local',
  'settings.mcp.serverId': 'server_id',
  'settings.mcp.displayName': 'display_name',
  'settings.mcp.transport': 'transport',
  'settings.mcp.transportOption.http': 'HTTP',
  'settings.mcp.transportOption.stdio': 'stdio',
  'settings.mcp.transportOption.websocket': 'WebSocket',
  'settings.mcp.transportOption.command': 'command',
  'settings.mcp.endpointOrCommand': 'endpoint_or_command',
  'settings.mcp.args': 'args (comma separated)',
  'settings.mcp.envRefs': 'env_refs (${VAR})',
  'settings.mcp.authType': 'auth_type',
  'settings.mcp.authTypeOption.none': 'none',
  'settings.mcp.authTypeOption.bearer': 'bearer',
  'settings.mcp.authTypeOption.basic': 'basic',
  'settings.mcp.authTypeOption.apiKey': 'api_key',
  'settings.mcp.authTypeOption.oauth': 'oauth',
  'settings.mcp.authEnvRef': 'auth_env_ref',
  'settings.mcp.timeoutMs': 'timeout_ms',
  'settings.mcp.rateLimit': 'rate_limit_rps',
  'settings.mcp.namespace': 'namespace',
  'settings.mcp.permissionScope': 'permission_scope (comma separated)',
  'settings.mcp.refreshPolicy': 'refresh_policy',
  'settings.mcp.retryMax': 'retry.max_retries',
  'settings.mcp.retryBackoff': 'retry.backoff_ms',
  'settings.mcp.enabled': 'Enable this MCP server',
  'settings.skills.moduleDesc': 'Manage skill path, priority, timeout, and capabilities.',
  'settings.skills.add': 'Add Skill',
  'settings.skills.skillFallback': 'Skill {index}',
  'settings.skills.sourceId': 'source_id',
  'settings.skills.kind': 'kind',
  'settings.skills.skillId': 'skill_id',
  'settings.skills.displayName': 'display_name',
  'settings.skills.path': 'path',
  'settings.skills.version': 'version',
  'settings.skills.priority': 'priority',
  'settings.skills.timeoutMs': 'timeout_ms',
  'settings.skills.allowedTools': 'allowed_tools (comma separated)',
  'settings.skills.requiredCapabilities': 'required_capabilities (comma separated)',
  'settings.skills.namespace': 'namespace',
  'settings.skills.enableFork': 'enable_fork',
  'settings.skills.fallbackSkillId': 'fallback_skill_id',
  'settings.skills.tags': 'tags (comma separated)',
  'settings.skills.enabled': 'Enable this Skill',
  'settings.skills.reloadCatalog': 'Reload Catalog',
  'settings.skills.reloadCatalogSuccess': 'Skills catalog reloaded',
  'settings.skills.reloadCatalogFailed': 'Failed to reload skills catalog',
  'settings.skills.catalogSize': 'Catalog Size',
  'settings.skills.forkableCount': 'Forkable',
  'settings.skills.loadedMode': 'Loaded Mode',
  'settings.skills.loadedModeRefreshing': 'Refreshing',
  'settings.skills.loadedModeReady': 'Ready',
  'settings.skills.runtimeCatalog': 'Runtime Catalog',
  'settings.skills.executionProbe': 'Execution Probe',
  'settings.skills.executionProbeDesc':
    'Run the selected skills against a query to inspect resolved policy and fork outputs.',
  'settings.skills.downloadRuntimeSnapshot': 'Download Runtime Snapshot',
  'settings.skills.queryLabel': 'Query',
  'settings.skills.selectedSkillIds': 'Selected Skill IDs',
  'settings.skills.actorMode': 'Actor Mode',
  'settings.skills.runProbe': 'Run Probe',
  'settings.skills.runningProbe': 'Running…',
  'settings.skills.runtimeSummaryTitle': 'Skill Runtime Summary',
  'settings.skills.runtimeSummaryDesc':
    'Inspect the resolved skills, policy, and fork trace returned by the probe run.',
  'settings.skills.defaultNamespace': 'Default',
  'settings.skills.executeQueryRequired': 'Execution query is required',
  'settings.skills.executeSkillRequired': 'Select at least one skill',
  'settings.skills.executeSuccess': 'Skill execution completed',
  'settings.skills.executeFailed': 'Skill execution failed',
  'settings.language.title': 'Language',
  'settings.account.title': 'Account',
  'settings.account.phone.title': 'Phone Number',
  'settings.account.phone.action': 'Bind Phone',
  'settings.account.phone.bound': 'Bound',
  'settings.account.phone.unbound': 'Not Bound',
  'settings.account.phone.hint':
    'Bind a phone number for social-login completion and account security checks.',
  'settings.about.title': 'About',
  'settings.about.description': 'Application details and service configuration',
  'settings.about.app': 'Application',
  'settings.about.configVersion': 'Config version',
  'settings.about.services': 'Service configuration',
  'settings.shortcuts.title': 'Keyboard Shortcuts',
  'settings.shortcuts.newChat': 'New chat',
  'settings.shortcuts.focusInput': 'Focus input',
  'settings.shortcuts.searchChats': 'Search chats',
  'settings.shortcuts.cancelClose': 'Cancel / Close',
  'settings.danger.title': 'Danger Zone',
  'settings.danger.signOut.title': 'Sign out',
  'settings.danger.signOut.desc': 'Clear local session and return to login',
  'settings.danger.signOut.action': 'Sign out',

  'serviceConfig.title': 'Service Configuration',
  'serviceConfig.agentService': 'Agent Service',
  'serviceConfig.memoryService': 'Memory Service',
  'serviceConfig.ragService': 'RAG Service',
  'serviceConfig.fileService': 'File Service',
  'serviceConfig.serviceUrl': 'Service URL',
  'serviceConfig.legacyTitle': 'Legacy Model Configuration',
  'serviceConfig.legacyDesc':
    'Legacy fields (model_provider / model_name). New routing prefers external-services config.',
  'serviceConfig.modelProvider': 'Model Provider',
  'serviceConfig.modelProviderPlaceholder': 'e.g., openai, anthropic',
  'serviceConfig.modelName': 'Model Name',
  'serviceConfig.modelNamePlaceholder': 'e.g., gpt-4, claude-3',
  'serviceConfig.save': 'Save Configuration',
  'serviceConfig.saved': 'Configuration saved successfully!',

  'modelConfig.title': 'Model Configuration',
  'modelConfig.desc':
    'Manage model entries in external-services (local/cloud). Edit endpoint, model, and parameters (JSON).',
  'modelConfig.add.title': 'Add entry (Service ID)',
  'modelConfig.add.placeholder': 'e.g., qwen3-30b / glm-4-5',
  'modelConfig.add.hint': 'Service ID is used as the YAML key; renaming is not supported.',
  'modelConfig.add.action': 'Add',
  'modelConfig.list.empty': 'No entries yet. Please add one first.',
  'modelConfig.list.default': 'Default',
  'modelConfig.list.endpoint': 'endpoint',
  'modelConfig.list.model': 'model',
  'modelConfig.editor.selectPrompt': 'Select an entry to edit.',
  'modelConfig.editor.serviceId': 'Service ID',
  'modelConfig.editor.displayName': 'Display name (name)',
  'modelConfig.editor.displayNamePlaceholder': 'e.g., Qwen3-30B',
  'modelConfig.editor.displayNameHint': 'Used for UI display; does not affect Service ID.',
  'modelConfig.editor.endpoint': 'Endpoint',
  'modelConfig.editor.endpointPlaceholder': 'e.g., https://dashscope.aliyuncs.com',
  'modelConfig.editor.modelLabel': 'Model',
  'modelConfig.editor.modelPlaceholder': 'e.g., Qwen/Qwen3-30B-A3B',
  'modelConfig.editor.parameters': 'Parameters (JSON object)',
  'modelConfig.editor.parametersPlaceholder': 'e.g., {"temperature":0.7,"max_tokens":2048}',
  'modelConfig.editor.parametersHint':
    'Tip: JSON is validated before saving. Use empty or {} to clear.',
  'modelConfig.editor.enabled': 'Enabled',
  'modelConfig.editor.type': 'Type',
  'modelConfig.editor.typePlaceholder': 'e.g., ollama / modelscope / zhipuai / http',
  'modelConfig.editor.typeHint': 'Type is required by backend; use http if unsure.',
  'modelConfig.editor.validateParams': 'Validate parameters JSON',
  'modelConfig.error.fetchFailed': 'Failed to load model configuration',
  'modelConfig.error.saveFailed': 'Failed to save model configuration',
  'modelConfig.addService': 'Add',
  'modelConfig.delete': 'Delete',
  'modelConfig.mode.local': 'Local',
  'modelConfig.mode.cloud': 'Cloud',
  'modelConfig.toast.enterId': 'Please enter a service ID (e.g., qwen3-30b)',
  'modelConfig.toast.duplicateId': 'Service already exists: {id}',
  'modelConfig.toast.added': 'Service added (remember to save)',
  'modelConfig.toast.deleted': 'Service deleted (remember to save)',
  'modelConfig.toast.paramsInvalid': 'Invalid parameters JSON',
  'modelConfig.toast.paramsMustObject':
    'parameters must be a JSON object (e.g., {"temperature":0.7})',
  'modelConfig.toast.saved': 'Model configuration saved',
  'modelConfig.toast.reset': 'Reset to server version (unsaved changes discarded)',
  'modelConfig.toast.refreshed': 'Refreshed',
  'modelConfig.confirmDelete': 'Delete "{id}"? This will apply after saving.',

  'workflow.title': 'Workflow Editor',
  'workflow.subtitle': 'Configure node-level model bindings with search and batch updates',
  'workflow.refreshScan': 'Refresh Scan',
  'workflow.scanRefreshed': 'Workflow scan refreshed',
  'workflow.searchTitle': 'Provider Model Search',
  'workflow.catalogCount': 'Models {models} / Profiles {profiles}',
  'workflow.searchPlaceholder': 'Search by node, file, function, or binding key',
  'workflow.filter.modelType': 'Type',
  'workflow.filter.performance': 'Performance',
  'workflow.filter.cost': 'Cost',
  'workflow.filter.region': 'Region',
  'workflow.batchTitle': 'Batch Binding',
  'workflow.selectedCount': '{count} nodes selected',
  'workflow.selectProfile': 'Select profile',
  'workflow.applyToSelected': 'Apply to selected',
  'workflow.saveComment': 'Change comment',
  'workflow.saveCommentPlaceholder': 'Optional note for this batch update',
  'workflow.clearSelection': 'Clear selection',
  'workflow.saveSelected': 'Save selected nodes',
  'workflow.saved': 'Node bindings saved',
  'workflow.emptyCallsites': 'No workflow model callsites were scanned.',
  'workflow.graphSummary': 'Dependency graph summary',
  'workflow.graphSummaryValue': 'Nodes {nodes} · Edges {edges} · Callsites {callsites}',
  'workflow.selectNode': 'Select node',
  'workflow.primaryProfile': 'Primary profile',
  'workflow.optionSummary': '{model} / {provider} / ${cost}/1k / {latency}ms / context {context}',
  'workflow.fallbackProfiles': 'Fallback profiles (comma separated)',
  'workflow.timeoutMs': 'timeout_ms',
  'workflow.retryMax': 'retry.max_retries',
  'workflow.retryBackoff': 'retry.backoff_ms',
  'workflow.scan.sseFallback': 'Realtime scan connection failed, switched to manual refresh.',

  // Knowledge Base
  'kb.title': 'Knowledge Base',
  'kb.refreshList': 'Refresh List',
  'kb.noKbs': 'No Knowledge Bases',
  'kb.create.title': 'Create New Knowledge Base',
  'kb.create.idPlaceholder': 'ID (e.g. math_kb)',
  'kb.create.namePlaceholder': 'Name',
  'kb.create.action': 'Create',
  'kb.select.title': 'Please select a knowledge base',
  'kb.select.desc': 'Select or create a new knowledge base from the left to start managing',
  'kb.status.enabled': 'Enabled',
  'kb.status.disabled': 'Disabled',
  'kb.refresh': 'Refresh',
  'kb.delete': 'Delete',
  'kb.tab.overview': 'Overview & Status',
  'kb.tab.ingest': 'Ingest',
  'kb.tab.playground': 'Playground',
  'kb.tab.config': 'Configuration',
  'kb.overview.status': 'Run Status',
  'kb.overview.status.ok': 'System Normal',
  'kb.overview.status.error': 'Abnormal',
  'kb.overview.docCount': 'Document Count',
  'kb.overview.chunkCount': 'Chunk Count',
  'kb.overview.indexSize': 'Index Size',
  'kb.overview.monitor': 'Retrieval Performance Monitor',
  'kb.overview.fetchMetrics': 'Fetch Latest Metrics',
  'kb.overview.noMetrics': 'No Metrics Data',
  'kb.overview.noDetailedChecks': 'No detailed checks available',
  'kb.ingest.title': 'Upload Documents',
  'kb.ingest.drop': 'Drag files here, or click to upload',
  'kb.ingest.support': 'Support PDF, TXT, Markdown, Image',
  'kb.ingest.pending': 'Files to Upload ({count})',
  'kb.ingest.chunkSize': 'Chunk Size',
  'kb.ingest.overlap': 'Overlap',
  'kb.ingest.concurrency': 'Concurrency',
  'kb.ingest.start': 'Start Upload & Ingest',
  'kb.ingest.progress': 'Job Progress',
  'kb.playground.title': 'Retrieval Test',
  'kb.playground.queryLabel': 'Query',
  'kb.playground.queryPlaceholder': 'Enter retrieval query...',
  'kb.playground.vector': 'Vector Search',
  'kb.playground.hybrid': 'Hybrid Search',
  'kb.playground.topK': 'Top K',
  'kb.playground.threshold': 'Threshold',
  'kb.playground.rerank': 'Enable Rerank',
  'kb.playground.runVector': 'Run Vector Search',
  'kb.playground.vectorTopK': 'Vec Top K',
  'kb.playground.keywordTopK': 'Key Top K',
  'kb.playground.rerankTopK': 'Rerank K',
  'kb.playground.results': 'Results',
  'kb.playground.selectedCount': 'Selected {count}',
  'kb.playground.vectorRes': 'Vector Results',
  'kb.playground.hybridRes': 'Hybrid Results',
  'kb.config.title': 'Basic Settings',
  'kb.config.enable': 'Enable Knowledge Base',
  'kb.config.save': 'Save Configuration',
  'kb.config.name': 'Name',
  'kb.config.desc': 'Description',
  'kb.config.embedding': 'Embedding Config (JSON)',
  'kb.config.vectorStore': 'Vector Store Config (JSON)',
  'kb.config.rag': 'RAG Params (JSON)',
  'kb.config.rerank': 'Rerank Config (JSON)',

  // Tooltips
  'tooltip.topK': 'The number of most similar document chunks to return.',
  'tooltip.scoreThreshold':
    'Minimum similarity score threshold. Documents below this score will be filtered out.',
  'tooltip.chunkSize': 'Size of document chunks (in characters), affecting semantic completeness.',
  'tooltip.overlap':
    'Number of overlapping characters between adjacent chunks to maintain context.',
  'tooltip.concurrency': 'Number of files processed concurrently, affecting ingestion speed.',
  'tooltip.rerank': 'Use a reranking model to rescore retrieval results for better accuracy.',
  'tooltip.hybridVectorTopK': 'Top K results returned by vector search in hybrid mode.',
  'tooltip.hybridKeywordTopK': 'Top K results returned by keyword search in hybrid mode.',
  'tooltip.hybridRerankTopK': 'Top K results returned after final reranking in hybrid mode.',

  // SubGraphNode

  'pc.unset': '(unset)',
  'pc.langgraph-add-node.title': 'LangGraph.add_node Core Parameters',
  'pc.langgraph-add-node.desc': 'Key parameters aligned with StateGraph.add_node',
  'pc.langgraph-add-node.key': 'Unique node key, recommended to match node id',
  'pc.langgraph-add-node.runnable': 'Node executor (Runnable/Callable) declaration',
  'pc.langgraph-add-node.defer': 'Whether to defer execution until end of run',
  'pc.langgraph-add-node.metadata': 'Node metadata, included in tracing/observability',
  'pc.langgraph-add-node.input_schema': 'Node input schema (optional)',
  'pc.langgraph-add-node.retry_policy': 'Retry policy object (see sub-parameters below)',
  'pc.langgraph-add-node.cache_policy': 'Cache policy object (see sub-parameters below)',
  'pc.langgraph-add-node.destinations': 'Destination node hints for visual branch targets',
  'pc.langgraph-retry-policy.title': 'LangGraph RetryPolicy',
  'pc.langgraph-retry-policy.desc': 'Fine-grained retry parameters',
  'pc.langgraph-retry-policy.initial_interval': 'Initial retry interval (seconds)',
  'pc.langgraph-retry-policy.backoff_factor': 'Exponential backoff factor',
  'pc.langgraph-retry-policy.max_interval': 'Maximum retry interval (seconds)',
  'pc.langgraph-retry-policy.max_attempts': 'Maximum retry attempts',
  'pc.langgraph-retry-policy.jitter': 'Whether to enable random jitter',
  'pc.langgraph-retry-policy.retry_on': 'Exception filter (exception type or predicate)',
  'pc.langgraph-cache-policy.title': 'LangGraph CachePolicy',
  'pc.langgraph-cache-policy.desc': 'Cache policy parameters',
  'pc.langgraph-cache-policy.key_func': 'Cache key generator function',
  'pc.langgraph-cache-policy.ttl': 'Cache TTL (seconds)',
  'pc.langchain-runnable-config.title': 'LangChain RunnableConfig',
  'pc.langchain-runnable-config.desc': 'Runtime config (tags/metadata/callbacks, etc.)',
  'pc.langchain-runnable-config.tags': 'Run tags (for tracing and filtering)',
  'pc.langchain-runnable-config.metadata': 'Run metadata',
  'pc.langchain-runnable-config.callbacks': 'Callback handlers',
  'pc.langchain-runnable-config.run_name': 'Run name',
  'pc.langchain-runnable-config.max_concurrency': 'Concurrency limit',
  'pc.langchain-runnable-config.recursion_limit': 'Recursion depth limit',
  'pc.langchain-runnable-config.configurable': 'Configurable runtime parameters dict',
  'pc.langchain-runnable-config.run_id': 'Unique run ID',
  'pc.chat-openai.title': 'LangChain ChatOpenAI Parameters',
  'pc.chat-openai.desc':
    'OpenAI/compatible model parameters (core fields editable, others use Advanced Editor)',
  'pc.chat-openai.model_name': 'Model name',
  'pc.chat-openai.model': 'Model name alias',
  'pc.chat-openai.temperature': 'Sampling temperature',
  'pc.chat-openai.max_tokens': 'Max output tokens',
  'pc.chat-openai.top_p': 'Nucleus sampling probability',
  'pc.chat-openai.n': 'Number of completions per request',
  'pc.chat-openai.stop': 'Stop sequences',
  'pc.chat-openai.max_retries': 'Max retries',
  'pc.chat-openai.request_timeout': 'Request timeout',
  'pc.chat-openai.presence_penalty': 'Presence penalty',
  'pc.chat-openai.frequency_penalty': 'Frequency penalty',
  'pc.chat-openai.seed': 'Random seed',
  'pc.chat-openai.streaming': 'Whether to stream output',
  'pc.chat-openai.stream_usage': 'Include token usage in stream',
  'pc.chat-openai.reasoning_effort': 'Reasoning effort',
  'pc.chat-openai.reasoning': 'Reasoning configuration',
  'pc.chat-openai.verbosity': 'Response verbosity level',
  'pc.chat-openai.logprobs': 'Return token logprobs',
  'pc.chat-openai.top_logprobs': 'Return top K logprobs',
  'pc.chat-openai.logit_bias': 'Logit bias mapping',
  'pc.chat-openai.model_kwargs': 'Pass-through extra model parameters',
  'pc.chat-openai.extra_body': 'Extra request body fields',
  'pc.chat-openai.default_headers': 'Default request headers',
  'pc.chat-openai.default_query': 'Default query parameters',
  'pc.chat-openai.include': 'Response include fields',
  'pc.chat-openai.service_tier': 'Service tier',
  'pc.chat-openai.store': 'Whether to persist request',
  'pc.chat-openai.truncation': 'Input truncation strategy',
  'pc.chat-openai.use_previous_response_id': 'Reuse previous response ID',
  'pc.chat-openai.use_responses_api': 'Whether to use Responses API',
  'pc.chat-gemini.title': 'LangChain Gemini Parameters',
  'pc.chat-gemini.desc': 'Google Gemini model parameters',
  'pc.chat-gemini.model': 'Model name',
  'pc.chat-gemini.temperature': 'Sampling temperature',
  'pc.chat-gemini.max_output_tokens': 'Max output tokens',
  'pc.chat-gemini.top_p': 'Nucleus sampling probability',
  'pc.chat-gemini.top_k': 'Top-k sampling',
  'pc.chat-gemini.n': 'Number of candidates',
  'pc.chat-gemini.max_retries': 'Max retries',
  'pc.chat-gemini.timeout': 'Request timeout',
  'pc.chat-gemini.response_mime_type': 'Response MIME type',
  'pc.chat-gemini.response_schema': 'Structured output schema',
  'pc.chat-gemini.safety_settings': 'Safety policy configuration',
  'pc.chat-gemini.thinking_budget': 'Thinking budget',
  'pc.chat-gemini.include_thoughts': 'Whether to include thinking content',
  'pc.chat-gemini.thinking_level': 'Thinking intensity level',
  'pc.chat-gemini.client_args': 'Underlying client arguments',
  'pc.chat-gemini.model_kwargs': 'Extra model parameters',
  'pc.chat-ollama.title': 'LangChain Ollama Parameters',
  'pc.chat-ollama.desc': 'Ollama model parameters (core editable + common extensions)',
  'pc.chat-ollama.model': 'Model name',
  'pc.chat-ollama.base_url': 'Ollama service URL',
  'pc.chat-ollama.temperature': 'Sampling temperature',
  'pc.chat-ollama.num_predict': 'Max generated tokens',
  'pc.chat-ollama.top_k': 'Top-k sampling',
  'pc.chat-ollama.top_p': 'Top-p sampling',
  'pc.chat-ollama.num_ctx': 'Context window size',
  'pc.chat-ollama.repeat_penalty': 'Repeat penalty',
  'pc.chat-ollama.seed': 'Random seed',

  'nodeLib.title': 'Node Library',
  'nodeLib.template': 'Template',
  'nodeLib.create': 'New',
  'nodeLib.remoteCatalog': 'Remote catalog driven',
  'nodeLib.localFallback': 'Local fallback (offline available)',
  'nodeLib.createTemplateHint': 'New template (same key auto-versioned)',
  'nodeLib.titlePlaceholder': 'Template title (e.g. Physics Solver)',
  'nodeLib.keyPlaceholder': 'Template key (auto-generated from title if empty)',
  'nodeLib.descPlaceholder': 'Description (optional)',
  'nodeLib.defaultsJsonPlaceholder': 'defaults JSON, e.g. {"runnable":{"type":"custom.runner"}}',
  'nodeLib.schemaJsonPlaceholder': 'editable schema JSON, e.g. {"type":"object","properties":{}}',
  'nodeLib.saving': 'Saving…',
  'nodeLib.saveTemplate': 'Save Template',
  'nodeLib.searchPlaceholder': 'Search nodes (key/title/desc/category)',
  'nodeLib.cardTooltip': 'Click to view node details; drag to canvas',
  'nodeLib.viewNode': 'View node details',
  'nodeLib.dragToCanvas': 'Drag to add to canvas',
  'nodeLib.publishing': 'Publishing…',
  'nodeLib.newVersion': 'New Version',
  'nodeLib.versions': 'Versions',
  'nodeLib.deleting': 'Deleting…',
  'nodeLib.versionHistory': 'Version History',
  'nodeLib.noVersions': 'No versions yet',
  'nodeLib.err.titleRequired': 'Template title is required',
  'nodeLib.err.keyRequired': 'Template key is required',
  'nodeLib.err.nodeTypeRequired': 'node_type is required',
  'nodeLib.err.invalidDefaultsJson': 'defaults JSON is not a valid object',
  'nodeLib.err.invalidSchemaJson': 'editable schema JSON is not a valid object',
  'nodeLib.toast.versionPublished': 'New template version published',
  'nodeLib.toast.created': 'Template created',
  'nodeLib.toast.saveFailed': 'Failed to save template',
  'nodeLib.toast.keyPublished': 'Template {key} new version published',
  'nodeLib.toast.publishFailed': 'Failed to publish new version',
  'nodeLib.toast.loadVersionsFailed': 'Failed to load versions',
  'nodeLib.toast.keyDeleted': 'Template {key} deleted',
  'nodeLib.toast.deleteFailed': 'Failed to delete template',
  'nodeLib.llm.chat.openai': 'OpenAI-compatible chat model',
  'nodeLib.llm.chat.anthropic': 'Anthropic Claude chat model',
  'nodeLib.llm.chat.gemini': 'Google Gemini chat model',
  'nodeLib.llm.chat.ollama': 'Local/private model (Ollama)',
  'nodeLib.llm.chat.openai_compatible': 'Any OpenAI-compatible gateway',
  'nodeLib.llm.embeddings.openai': 'Embeddings (OpenAI)',
  'nodeLib.llm.embeddings.ollama': 'Embeddings (local)',
  'nodeLib.agent.deep.planner': 'Deep Agents planner template',
  'nodeLib.agent.deep.delegate': 'Deep Agents delegate template',
  'nodeLib.prompt.template': 'Variable interpolation prompt template',
  'nodeLib.prompt.chat': 'Multi-role message prompt',
  'nodeLib.prompt.system': 'System message fragment',
  'nodeLib.prompt.human': 'User message fragment',
  'nodeLib.prompt.few_shot': 'Few-shot example prompt',
  'nodeLib.prompt.output_parser': 'Structured output parser',
  'nodeLib.retriever.ragflow': 'RAGFlow API retrieval (local)',
  'nodeLib.retriever.lightrag': 'LightRAG knowledge graph query (local)',
  'nodeLib.retriever.vector': 'Vector retrieval (TopK, self-hosted RAG)',
  'nodeLib.retriever.bm25': 'Keyword retrieval (BM25, self-hosted RAG)',
  'nodeLib.retriever.hybrid': 'Vector + keyword hybrid retrieval (self-hosted RAG)',
  'nodeLib.retriever.rerank': 'Rerank (Xinference Reranker)',
  'nodeLib.retriever.web_search': 'Web search retrieval (not implemented)',
  'nodeLib.tool.http': 'HTTP API call',
  'nodeLib.tool.python': 'Python interpreter tool',
  'nodeLib.tool.wolfram': 'Wolfram computation tool',
  'nodeLib.tool.file_reader': 'Read file/attachment content',
  'nodeLib.tool.json': 'JSON processing/transformation',
  'nodeLib.tool.sql': 'Database query tool',
  'nodeLib.tool.shell': 'Controlled command execution (sandbox)',
  'nodeLib.tool.custom': 'Custom tool (extension point)',
  'nodeLib.memory.buffer': 'Short-term conversation memory',
  'nodeLib.memory.summary': 'Conversation summary memory',
  'nodeLib.memory.kv': 'Key-value variable store',
  'nodeLib.memory.checkpoint': 'State checkpoint (replayable)',
  'nodeLib.memory.thread': 'Thread store',
  'nodeLib.logic.branch': 'Conditional branch',
  'nodeLib.logic.switch': 'Multi-way dispatch (switch/case)',
  'nodeLib.logic.merge': 'Merge multiple inputs',
  'nodeLib.logic.map': 'Map over list items',
  'nodeLib.logic.reduce': 'Aggregate/reduce',
  'nodeLib.logic.retry': 'Retry on failure',
  'nodeLib.logic.guard': 'Parameter validation/assertion',
  'nodeLib.logic.subgraph': 'SubGraph (collapsible/nestable)',
  'nodeLib.output.text': 'Text output',
  'nodeLib.output.json': 'JSON output',
  'nodeLib.output.markdown': 'Markdown output',
  'nodeLib.output.stream': 'Stream output (SSE/Token)',
  'nodeLib.custom.input': 'Input node (custom)',
  'nodeLib.custom.transform': 'Custom data transform',
  'nodeLib.custom.click': 'User interaction trigger',
  'nodeLib.custom.runner': 'Custom runner',
  'nodeLib.custom.auth': 'Auth/key management',

  // DynamicNodeForm
  'dnf.modelConfigTip': 'Please configure models in Global Model Settings first',
  'dnf.error.jsonObjectRequired': 'Must be a JSON object',
  'dnf.error.jsonArrayRequired': 'Must be a JSON array',
  'dnf.error.jsonParseFailed': 'JSON parse failed',
  'dnf.error.invalidLine': 'Invalid line: {line}',
  'dnf.error.emptyKey': 'Key cannot be empty: {line}',
  'dnf.error.required': '{label} is required',
  'dnf.error.mustBeNumber': '{label} must be a number',
  'dnf.error.min': '{label} must not be less than {min}',
  'dnf.error.max': '{label} must not be greater than {max}',
  'dnf.httpBody.json': 'JSON',
  'dnf.httpBody.rawText': 'Raw Text',
  'dnf.placeholder.rawRequestBody': 'raw request body',
  'dnf.placeholder.responsePath': 'payload.data.items',
  'dnf.placeholder.fromPath': 'from path',
  'dnf.placeholder.toKey': 'to key',
  'dnf.placeholder.headerMap': 'Header-A: value\nHeader-B: value',
  'dnf.placeholder.field': 'field',
  'dnf.placeholder.value': 'value',
  'dnf.placeholder.sourceFilter': 'kb, notes',
  'dnf.parseJsonResponse': 'Parse JSON response',
  'dnf.raiseOnUnexpectedStatus': 'Raise on unexpected status',
  'dnf.statusHandlers': 'Status Handlers',
  'dnf.noStatusHandlers': 'No status handlers yet.',
  'dnf.extractPathOptional': 'extract path (optional)',
  'dnf.targetKeyOptional': 'target key (optional)',
  'dnf.addStatusHandler': 'Add status handler',
  'dnf.responseMapping': 'Response Mapping',
  'dnf.noMappingRules': 'No mapping rules yet.',
  'dnf.required': 'Required',
  'dnf.addMapping': 'Add mapping',
  'dnf.noFilterRules': 'No filter rules yet. Click below to add.',
  'dnf.addRule': 'Add rule',
  'dnf.filterStrategy': 'Filter Strategy',
  'dnf.noStructuredFilterRules': 'No structured filter rules yet.',
  'dnf.addFilterRule': 'Add filter rule',
  'dnf.lightragSearchMode': 'LightRAG Search Mode',
  'dnf.lightrag.local': 'Local (entity subgraph retrieval)',
  'dnf.lightrag.global': 'Global (community summary)',
  'dnf.lightrag.hybrid': 'Hybrid (Local + Global fusion)',
  'dnf.lightrag.naive': 'Naive (direct vector retrieval)',
  'dnf.lightragDesc':
    'Local: entity-relation subgraph retrieval; Global: community summary retrieval; Hybrid: both fused; Naive: standard vector similarity.',
  'dnf.ragflowConfig': 'RAGFlow Config',
  'dnf.ragflowDesc':
    'Enter RAGFlow dataset IDs (comma-separated) in the "Dataset IDs" field above. RAGFlow handles hybrid retrieval internally.',
  'dnf.fusionStrategy': 'Fusion Strategy (Fusion / Blend)',
  'dnf.rerankStrategy': 'Rerank Strategy',
  'dnf.enableRerank': 'Enable reranking',
  'dnf.rerankNodeHint': 'This is a dedicated Rerank node; reranking is enabled by default.',
  'dnf.noRouteMap': 'No route mappings yet. Click below to add.',
  'dnf.noToolsBound':
    'No tools bound. Check tools below and the model will decide when to call them via Function Calling.',
  'dnf.toolsBound': '{count} tool(s) bound — model will decide when to call',
  'dnf.noMessages': 'No messages yet. Click below to add.',
  'dnf.nameOptional': 'name (optional)',
  'dnf.moveUp': 'Move up',
  'dnf.messageContent': 'Message content',
  'dnf.addMessage': 'Add message',
  'dnf.enable': 'Enable',
  'dnf.pleaseSelect': 'Please select',
  'dnf.modelSelector': 'Model Selector',
  'dnf.modelSortHint':
    'Sorted by node requirements (capability match, test status, local/cloud preference, etc.).',
  // DynamicNodeForm — Tool Catalog
  'dnf.tool.python_interpreter.name': 'Python Sandbox Interpreter',
  'dnf.tool.python_interpreter.desc':
    '(Retired — use Python Sandbox Interpreter instead)',
  'dnf.tool.wolfram_alpha.desc':
    'Symbolic integration, equation solving, unit conversion, physics constants',
  'dnf.tool.physics_calculator.name': 'Physics Formula Calculator',
  'dnf.tool.physics_calculator.desc':
    '30+ physics formulas (mechanics/electromagnetism/waves/thermodynamics)',
  'dnf.tool.wikipedia.desc':
    'Query Wikipedia for physics concepts, scientist biographies, theorem history, etc.',
  'dnf.tool.arxiv.name': 'ArXiv Paper Search',
  'dnf.tool.arxiv.desc': 'Search arXiv physics/math/CS paper abstracts',
  'dnf.tool.duckduckgo.name': 'DuckDuckGo Search',
  'dnf.tool.duckduckgo.desc':
    'Free web search, no API Key required, suitable for real-time info retrieval',
  'dnf.tool.stackexchange.desc': 'Search Physics / Math StackExchange Q&A communities',
  'dnf.tool.wikidata.desc':
    'Structured knowledge queries (physical constants, unit definitions, entity relations)',
  'dnf.tool.semantic_scholar.desc': 'Semantic paper search and citation graph analysis',
  'dnf.tool.tavily.name': 'Tavily Search',
  'dnf.tool.tavily.desc':
    'AI-native web search engine, returns structured results (requires API Key)',
  'dnf.tool.pubmed.name': 'PubMed Literature Search',
  'dnf.tool.pubmed.desc': 'Search biomedical and biophysics literature',
  'dnf.tool.nasa.desc': 'Access NASA API for astronomy/space physics data and images',
  'dnf.tool.youtube.name': 'YouTube Search',
  'dnf.tool.youtube.desc': 'Search physics teaching videos and educational content',

  'kb.config.modelSelect': 'Model Selection',
  'kb.config.selectProvider': 'Select Provider',
  'kb.config.selectModel': 'Select Model',
  'kb.config.baseUrl': 'Base URL',
  'kb.config.timeout': 'Timeout (s)',
  'kb.config.concurrency': 'Concurrency',
  'kb.config.provider': 'Provider',
  'kb.config.connection': 'Connection (JSON)',
  'kb.config.chunkSize': 'Chunk Size',
  'kb.config.overlap': 'Overlap',
  'kb.config.topK': 'Top K',
  'kb.config.scoreThreshold': 'Score Threshold',
  'kb.config.hybridVectorWeight': 'Hybrid Vector Weight',
  'kb.config.hybridKeywordWeight': 'Hybrid Keyword Weight',
  'kb.config.rerankTopK': 'Top K',
  'kb.config.modelRefreshed': 'Model list refreshed',
  'kb.config.modelRefreshFailed': 'Failed to refresh model list',
  'kb.config.refreshModels': 'Refresh Models (Auto-discover Local Models)',
  'kb.config.noProviders': 'No providers found',
  'kb.config.noModels': 'No models found',
  'kb.config.noModelsHint':
    'No models found. Please configure providers in Settings > Model Providers or click refresh to discover local models.',

  // Thinking Labels
  'thinkingLabel.node.file_context_enricher': 'File Processing',
  'thinkingLabel.node.role_intent': 'Role Recognition',
  'thinkingLabel.node.emotion_analyzer': 'Emotion Analysis',
  'thinkingLabel.node.skill_router': 'Skill Routing',
  'thinkingLabel.node.teacher_discussion_designer': 'Discussion Design',
  'thinkingLabel.node.teacher_lesson_planner': 'Lesson Planning',
  'thinkingLabel.node.conversation_summarizer': 'Conversation Compression',
  'thinkingLabel.node.error_review': 'Error Review',
  'thinkingLabel.node.multimodal': 'Multimodal Processing',
  'thinkingLabel.node.intent_classifier': 'Intent Classification',
  'thinkingLabel.node.rag_retrieval': 'Knowledge Retrieval',
  'thinkingLabel.node.supervisor': 'Task Dispatch',
  'thinkingLabel.node.solver_kernel': 'Solver Kernel',
  'thinkingLabel.node.socratic_coach': 'Socratic Coaching',
  'thinkingLabel.node.progressive_tutor': 'Progressive Tutoring',
  'thinkingLabel.node.teacher_review': 'Teacher Review',
  'thinkingLabel.node.student_response_predictor': 'Student Response Prediction',
  'thinkingLabel.node.web_search_fallback': 'Web Search',
  'thinkingLabel.node.sop_extractor': 'Process Extraction',
  'thinkingLabel.node.knowledge_writer': 'Knowledge Update',
  'thinkingLabel.node.student_profiler': 'Student Profiling',
  'thinkingLabel.node.knowledge_explainer': 'Knowledge Explanation',
  'thinkingLabel.node.clarification_planner': 'Clarification Planning',
  'thinkingLabel.node.clarification_batch': 'Batch Clarification',
  'thinkingLabel.node.clarification_ask': 'Step-by-step Asking',
  'thinkingLabel.node.targeted_generation': 'Targeted Generation',
  'thinkingLabel.node.physics_copilot': 'Physics Copilot',
  'thinkingLabel.node.capability': 'Capability Check',
  'thinkingLabel.node.skill_planner': 'Skill Planning',
  'thinkingLabel.node.skill_materializer': 'Skill Materialize',
  'thinkingLabel.node.forked_skill_runner': 'Forked Skill Run',
  'thinkingLabel.node.interactive_model': 'Interactive Solver',
  'thinkingLabel.node.model': 'Model Reasoning',
  'thinkingLabel.node.copilot_entry': 'Request Orchestration',
  'thinkingLabel.node.interactive_tools': 'Tool Execution',
  'thinkingLabel.node.interactive_finalize': 'Result Finalization',
  'thinkingLabel.emotion.frustrated': 'Frustrated',
  'thinkingLabel.emotion.confused': 'Confused',
  'thinkingLabel.emotion.anxious': 'Anxious',
  'thinkingLabel.emotion.curious': 'Curious',
  'thinkingLabel.emotion.confident': 'Confident',
  'thinkingLabel.emotion.neutral': 'Neutral',
  'thinkingLabel.strategy.deescalate_and_scaffold': 'De-escalate + Scaffold',
  'thinkingLabel.strategy.clarify_with_steps': 'Step-by-step Clarification',
  'thinkingLabel.strategy.supportive_guidance': 'Supportive Guidance',
  'thinkingLabel.strategy.challenge_with_extension': 'Challenge with Extension',
  'thinkingLabel.strategy.deeper_reasoning': 'Deeper Reasoning',
  'thinkingLabel.strategy.default_socratic': 'Socratic Guidance',
  'thinkingLabel.skill.socratic-scaffold': 'Socratic Scaffold',
  'thinkingLabel.skill.emotion-deescalation': 'Emotion De-escalation',
  'thinkingLabel.skill.concept-mapping': 'Concept Mapping',
  'thinkingLabel.skill.problem-decomposition': 'Problem Decomposition',
  'thinkingLabel.skill.metacognitive-prompting': 'Metacognitive Prompting',
  'thinkingLabel.skill.analogical-reasoning': 'Analogical Reasoning',
  'thinkingLabel.skill.visual-representation': 'Visual Representation',
  'thinkingLabel.skill.error-analysis': 'Error Analysis',
  'thinkingLabel.skill.progressive-hints': 'Progressive Hints',
  'thinkingLabel.skill.real-world-connection': 'Real-world Connection',
  'thinkingLabel.skill.knowledge-delivery': 'Knowledge Delivery',
  'thinkingLabel.skill.interactive-clarification': 'Interactive Clarification',
  'thinkingLabel.paramValue.unset': 'Not set',

  // Socratic Coaching Interrupt
  'socratic.title': 'Guided Questioning',
  'socratic.round': 'Step {current} of {total}',
  'socratic.roundEstimated': 'Step {current}, about {total} steps',
  'socratic.hint': '💡 Hint',
  'socratic.previousQA': 'Previous conversation',
  'socratic.answerPlaceholder': 'Type your answer...',
  'socratic.submit': 'Submit Answer',
  'socratic.resolved': 'Answered',
  'socratic.submitting': 'Submitting...',
  'socratic.knowledgeReview': 'Related Knowledge',
  'socratic.problemContext': 'Problem context',

  // Error Review Interrupt
  'errorReview.title': 'Error Review',
  'errorReview.knowledgeReview': 'Knowledge Review',
  'errorReview.answerPlaceholder': 'Type your answer...',
  'errorReview.next': 'Submit & Continue',
  'errorReview.finish': 'Submit & Finish',
  'errorReview.submitting': 'Submitting...',
  'errorReview.correct': 'correct',

  // Teacher Interview Interrupt
  'teacher.interview.title': 'Teaching Content Design',
  'teacher.interview.next': 'Next Question',
  'teacher.interview.generate': 'Start Generating',
  'teacher.interview.customPlaceholder': 'Enter custom content...',
  'teacher.interview.stale': 'This session has ended — this question card is no longer active',
  'teacher.interview.contentType.lesson_plan': 'Lesson Plan',
  'teacher.interview.contentType.exam': 'Exam Design',
  'teacher.interview.contentType.experiment': 'Experiment Plan',
  'teacher.interview.contentType.review': 'Review Plan',
  'teacher.interview.contentType.general': 'Teaching Content',
  'teacher.review.title': 'Teacher Review',
  'teacher.review.preview': 'Artifact Preview',
  'teacher.review.approve': 'Approve',
  'teacher.review.requestChanges': 'Request Changes',
  'teacher.review.stop': 'Stop',
  'teacher.review.feedbackLabel': 'Add feedback before sending back for revision',
  'teacher.review.feedbackPlaceholder': 'Describe what should be revised or expanded...',
  'teacher.review.submitting': 'Submitting...',
  'teacher.review.contentType.lesson_plan': 'Lesson Plan',
  'teacher.review.contentType.discussion': 'Discussion Design',
  'teacher.review.contentType.exam': 'Exam Design',
  'teacher.review.contentType.experiment': 'Experiment Plan',
  'teacher.review.contentType.review': 'Review Plan',
  'teacher.review.contentType.general': 'Teaching Content',

  // Versioned model settings workspace
  'modelSettings.ui.providerTitle': 'Model providers and deployments',
  'modelSettings.ui.workspaceSubtitle': 'Manage connection credentials, multiple model deployments, modality protocols, tests, and runtime status by provider. The server revision is authoritative.',
  'modelSettings.ui.workspacePreferences': 'Model workspace preferences',
  'modelSettings.ui.workspacePreferencesHelp': 'Auto-scan and default-binding preferences save separately and do not change provider connections or deployments.',
  'modelSettings.ui.overview': 'Model settings overview',
  'modelSettings.ui.connections': 'Provider connections',
  'modelSettings.ui.deployments': 'Model deployments',
  'modelSettings.ui.runtimeActive': 'Active at runtime',
  'modelSettings.ui.runtimePending': 'Waiting for runtime confirmation',
  'modelSettings.ui.runtimeFailed': 'Runtime call failed',
  'modelSettings.ui.revisionConfig': 'Config revision',
  'modelSettings.ui.revisionRuntime': 'Runtime revision',
  'modelSettings.ui.serverRevision': 'Server revision',
  'modelSettings.ui.filters': 'Filters and search',
  'modelSettings.ui.filterByModality': 'Filter by model capability',
  'modelSettings.ui.filterAll': 'All capabilities',
  'modelSettings.ui.searchLabel': 'Search providers or models',
  'modelSettings.ui.searchPlaceholder': 'Search provider, model name, or code…',
  'modelSettings.ui.addCustomProvider': 'Add custom provider',
  'modelSettings.ui.refreshState': 'Refresh settings state',
  'modelSettings.ui.loading': 'Loading saved settings…',
  'modelSettings.ui.noProviders': 'No providers match. Add a custom provider to configure one.',
  'modelSettings.ui.configureProvider': 'Configure provider',
  'modelSettings.ui.connectionState': 'Connection and credential',
  'modelSettings.ui.testState': 'Test receipt',
  'modelSettings.ui.runtimeState': 'Runtime effect',
  'modelSettings.ui.saved': 'Saved',
  'modelSettings.ui.notConfigured': 'Not configured',
  'modelSettings.ui.testsCurrent': '{count} current tests',
  'modelSettings.ui.noCurrentTest': 'No current test',
  'modelSettings.ui.runtimeActiveCount': '{count} active',
  'modelSettings.ui.runtimeInactive': 'Inactive',
  'modelSettings.ui.noDeployments': 'No model deployments yet',
  'modelSettings.ui.customProviderTitle': 'Add a custom OpenAI-compatible provider',
  'modelSettings.ui.providerDetailDescription': 'Configure connections and multiple model deployments under one provider. Save, test, and runtime state are tracked separately.',
  'modelSettings.ui.errorSummaryTitle': 'Please review these issues',
  'modelSettings.ui.draftRevisionConflict': 'Another tab updated model settings. Close and reopen this panel to load the latest revision.',
  'modelSettings.ui.connectionHeading': 'Provider connections and credentials',
  'modelSettings.ui.connectionHelp': 'Each connection stores its own endpoint and credential. Leave the key blank to keep the saved credential.',
  'modelSettings.ui.addConnection': 'Add connection',
  'modelSettings.ui.connection': 'Connection',
  'modelSettings.ui.baseUrl': 'Service URL',
  'modelSettings.ui.apiKey': 'API key',
  'modelSettings.ui.apiKeyHelp': 'Keys are never shown again. Enter a new value to replace this connection credential.',
  'modelSettings.ui.savedKeyPlaceholder': 'Saved (ending {last4}); leave blank to keep',
  'modelSettings.ui.newKeyPlaceholder': 'Enter API key (optional)',
  'modelSettings.ui.savedCredential': 'Credential stored on server',
  'modelSettings.ui.noSavedCredential': 'No credential saved',
  'modelSettings.ui.removeConnection': 'Remove connection',
  'modelSettings.ui.removeConnectionBlocked': 'This connection is still used by a deployment. Unbind the model first.',
  'modelSettings.ui.customProviderHelp': 'For custom OpenAI-compatible APIs. Credentials are used only by an approved server connection.',
  'modelSettings.ui.providerCode': 'Provider code',
  'modelSettings.ui.providerName': 'Provider name',
  'modelSettings.ui.deploymentsHeading': 'Model deployments',
  'modelSettings.ui.deploymentsHelp': 'Configure separate chat, vision, embedding, rerank, and image models under the same provider.',
  'modelSettings.ui.discoverModels': 'Discover models',
  'modelSettings.ui.discoveryResult': 'Catalog refreshed; found {count} models.',
  'modelSettings.ui.discoveryFailed': 'Model discovery failed. Check the connection and service, then retry.',
  'modelSettings.ui.catalogModelCount': 'Available model catalog: {count}',
  'modelSettings.ui.addDeployment': 'Add model deployment',
  'modelSettings.ui.noDeploymentsInDrawer': 'This provider has no model deployments yet.',
  'modelSettings.ui.newDeployment': 'New model deployment',
  'modelSettings.ui.modelName': 'Model name',
  'modelSettings.ui.modelNamePlaceholder': 'Choose a catalog model or enter a provider model ID',
  'modelSettings.ui.modality': 'Model capability',
  'modelSettings.ui.enabled': 'Enable deployment',
  'modelSettings.ui.defaultBinding': 'Set as default for this capability',
  'modelSettings.ui.parametersFor': '{modality} parameters',
  'modelSettings.ui.protocol': 'Adapter protocol',
  'modelSettings.ui.testUnsaved': 'Unsaved configuration',
  'modelSettings.ui.testConnection': 'Test connection',
  'modelSettings.ui.testProtocol': 'Validate model protocol offline',
  'modelSettings.ui.testVerified': 'Test passed',
  'modelSettings.ui.testContractValidated': 'Offline protocol validated',
  'modelSettings.ui.testFailed': 'Test failed',
  'modelSettings.ui.testUnsupported': 'Testing unsupported',
  'modelSettings.ui.testUntested': 'Not tested',
  'modelSettings.ui.testStale': 'Configuration changed; test is stale',
  'modelSettings.ui.saveBeforeTest': 'Save the configuration before running a test.',
  'modelSettings.ui.offlineOnlyHint': 'The model protocol is checked locally. No provider request is sent.',
  'modelSettings.ui.protocolUnsupported': 'The image model protocol is unverified and cannot be tested or invoked yet.',
  'modelSettings.ui.temperature': 'Temperature',
  'modelSettings.ui.maxTokens': 'Maximum output tokens',
  'modelSettings.ui.extraParams': 'Extra parameters (JSON object)',
  'modelSettings.ui.extraParamsHelp': 'Advanced provider parameters are saved as a JSON object. Invalid JSON blocks saving.',
  'modelSettings.ui.dimensions': 'Vector dimensions',
  'modelSettings.ui.batchSize': 'Batch size',
  'modelSettings.ui.topN': 'Result count (top_n)',
  'modelSettings.ui.returnDocuments': 'Return document text',
  'modelSettings.ui.imageSize': 'Image size',
  'modelSettings.ui.recommendedImageSizes': 'Enter a custom width × height; suggestions follow the provider recommendations.',
  'modelSettings.ui.steps': 'Inference steps',
  'modelSettings.ui.guidanceScale': 'Guidance scale',
  'modelSettings.ui.seed': 'Random seed',
  'modelSettings.ui.watermark': 'Add watermark',
  'modelSettings.ui.aspectRatio': 'Aspect ratio',
  'modelSettings.ui.promptOptimizer': 'Enable prompt optimizer',
  'modelSettings.ui.duration': 'Duration (seconds)',
  'modelSettings.ui.removeDeployment': 'Remove deployment',
  'modelSettings.ui.save': 'Save model settings',
  'modelSettings.ui.saving': 'Saving…',
  'modelSettings.ui.cancel': 'Cancel',
  'modelSettings.ui.discardDraftConfirm': 'Closing will discard this unsaved draft. Continue?',
  'modelSettings.ui.errorProviderCode': 'Use 1–64 lowercase letters, digits, underscores, or hyphens; start with a letter or digit.',
  'modelSettings.ui.errorProviderName': 'Enter a provider name.',
  'modelSettings.ui.errorBaseUrl': 'Enter a valid HTTP or HTTPS URL without a username or password.',
  'modelSettings.ui.errorModelName': 'Enter a model name.',
  'modelSettings.ui.errorConnection': 'Choose a valid provider connection.',
  'modelSettings.ui.errorExtraParams': 'Enter a valid JSON object, for example {"top_p":0.8}.',
  'modelSettings.ui.errorSettingsNotLoaded': 'Settings have not loaded from the server. Wait for the load to finish before saving.',
  'modelSettings.ui.errorSave': 'Could not save model settings. Review the fields and retry.',
  'modelSettings.ui.errorTest': 'The model test failed. Check the connection and retry.',
  'modelSettings.ui.modality.chat': 'Chat',
  'modelSettings.ui.modality.vision_input': 'Vision input',
  'modelSettings.ui.modality.embedding': 'Embedding',
  'modelSettings.ui.modality.rerank': 'Rerank',
  'modelSettings.ui.modality.image_generation': 'Image generation',
  'modelSettings.ui.modality.video_generation': 'Video generation',
  'modelSettings.ui.modality.tts': 'Text to speech',
  'modelSettings.ui.modality.speech2text': 'Speech to text',
  'modelSettings.ui.modality.moderation': 'Moderation',
  'modelSettings.ui.providerCategory.cloud-hosted': 'Cloud hosted',
  'modelSettings.ui.providerCategory.local-selfhosted': 'Local self-hosted',
  'modelSettings.ui.providerCategory.openai-compatible': 'OpenAI compatible',
  'modelSettings.ui.providerCategory.custom': 'Custom',
  'modelSettings.ui.defaultTag': 'Default',

  // Model Provider Center
  'modelProvider.cap.all': 'All',
  'modelProvider.cap.llm': 'LLM',
  'modelProvider.cap.embedding': 'Embedding',
  'modelProvider.cap.rerank': 'Rerank',
  'modelProvider.cap.vision': 'Vision',
  'modelProvider.cap.tts': 'TTS',
  'modelProvider.title': 'Model Provider Management',
  'modelProvider.subtitle':
    'Configure model providers and test connectivity. Tested providers can be used in workflow editor and knowledge base.',
  'modelProvider.catalogCount': 'Catalog',
  'modelProvider.configuredCount': 'Configured',
  'modelProvider.testedCount': 'Tested',
  'modelProvider.fallbackHint': '(Using frontend minimal catalog fallback)',
  'modelProvider.autoDetect': 'Auto Detect Models',
  'modelProvider.autoDetectTitle': 'Scan all tested providers to auto-discover available models',
  'modelProvider.autoDetectNoProviders':
    'No tested providers found. Please configure and test at least one provider first.',
  'modelProvider.autoDetectSuccess': 'Scanned {count} providers for available models',
  'modelProvider.autoDetectFailed': 'Auto model detection failed',
  'modelProvider.refresh': 'Refresh',
  'modelProvider.refreshTitle': 'Refresh provider catalog and saved configs',
  'modelProvider.searchPlaceholder': 'Search provider name, code, or capability tags…',
  'modelProvider.noMatch': 'No providers matched. Try adjusting search or capability filter.',
  'modelProvider.itemCount': '{count} items',
  'modelProvider.registryTitle': 'Model Registry Center',
  'modelProvider.registrySubtitle':
    'Auto-scan + pre-integrated model metadata (ModelScope / HuggingFace / Ollama)',
  'modelProvider.refreshModels': 'Refresh Model Catalog',
  'modelProvider.compareSelected': 'Compare Selected',
  'modelProvider.compareMax': 'Compare up to 3 models',
  'modelProvider.searchModels': 'Search models/tags/capabilities',
  'modelProvider.allCategories': 'All Categories',
  'modelProvider.capabilityFilter': 'Capability (e.g. chat/tool_calling)',
  'modelProvider.tagFilter': 'Tag (e.g. cn_optimized)',
  'modelProvider.localOnly': 'Local Only',
  'modelProvider.testedOnly': 'Tested Only',
  'modelProvider.modelCount': 'Models: {count}; Compare: {selected}/3',
  'modelProvider.deployLocal': 'Local (Ollama)',
  'modelProvider.deployCloud': 'Cloud',
  'modelProvider.testedOk': 'Tested OK',
  'modelProvider.notTested': 'Not Tested',
  'modelProvider.selected': 'Selected',
  'modelProvider.addCompare': 'Add to Compare',

  // Model Provider Card
  'modelProvider.card.testProtocol': 'Test Protocol',
  'modelProvider.card.noTestProtocol': 'Test protocol not supported',
  'modelProvider.card.testable': 'Testable ({protocol})',
  'modelProvider.card.statusTested': 'Tested OK',
  'modelProvider.card.statusIncomplete': 'Incomplete Config',
  'modelProvider.card.statusUntested': 'Not Tested',
  'modelProvider.card.unfavorite': 'Unfavorite',
  'modelProvider.card.favorite': 'Favorite',
  'modelProvider.card.apiKeySaved': 'Saved',
  'modelProvider.card.apiKeySavedMask': 'Saved (****{last4})',
  'modelProvider.card.apiKeyNotSet': 'Not Set',
  'modelProvider.card.lastTest': 'Last Test',
  'modelProvider.card.settings': 'Settings',
  'modelProvider.card.testConnection': 'Test Connection',
  'modelProvider.card.testTitle': 'Test connection using saved config or recommended defaults',
  'modelProvider.card.testUnsupportedTitle': 'Please select a provider that supports test protocol',
  'modelProvider.card.noTestHint': 'Test protocol not supported (config save only)',
  'modelProvider.card.noTestHintDetail':
    'This provider currently only supports saving config, live connection test is not supported',

  // Model Provider Editor Drawer
  'modelProvider.editor.desc':
    'Provider configuration (recommended defaults + pre-integrated model picker + custom model). Test connection is a live request;',
  'modelProvider.editor.noApiKeyNeeded': 'This provider typically does not require an API Key.',
  'modelProvider.editor.apiKeyReuse': 'Leave api_key empty to reuse saved key.',
  'modelProvider.editor.apiKeyPlaceholderNone':
    'Local models typically do not need API Key (leave empty)',
  'modelProvider.editor.apiKeyPlaceholderSaved': 'Saved{mask}, leave empty to keep',
  'modelProvider.editor.apiKeyPlaceholderNew': 'Enter API Key (leave empty if not set)',
  'modelProvider.editor.apiKeyHintNone':
    'Local models typically do not need a key; fill in if your proxy service requires auth.',
  'modelProvider.editor.apiKeyHintRequired':
    'Plaintext is not shown for security. Enter a new value to update. Leave empty to keep saved key.',
  'modelProvider.editor.discoverOllama': 'Discover Local Models',
  'modelProvider.editor.discoverOllamaTitle': 'Discover local models (Ollama /api/tags)',
  'modelProvider.editor.refreshModels': 'Refresh Model Catalog',
  'modelProvider.editor.refreshModelsTitle': 'Refresh model catalog for this provider',
  'modelProvider.editor.toggleCustomTitle': 'Toggle custom model (manual input) mode',
  'modelProvider.editor.useDropdown': 'Use Dropdown',
  'modelProvider.editor.addModel': 'Add Model',
  'modelProvider.editor.searchModel': 'Search or enter model name',
  'modelProvider.editor.customModelHint':
    'Custom model mode. Test connection first; it will be auto-added to model catalog on success.',
  'modelProvider.editor.modelInfoTitle':
    'Model capabilities and defaults (based on current provider model config)',
  'modelProvider.editor.categories': 'Categories',
  'modelProvider.editor.capabilities': 'Capabilities',
  'modelProvider.editor.contextWindow': 'Context Window',
  'modelProvider.editor.maxOutput': 'Max Output',
  'modelProvider.editor.tokens': '{count} tokens',
  'modelProvider.editor.notProvided': 'Not provided',
  'modelProvider.editor.reasoning': 'Reasoning',
  'modelProvider.editor.toolCalling': 'Tool Calling',
  'modelProvider.editor.visionInput': 'Vision Input',
  'modelProvider.editor.supported': 'Supported',
  'modelProvider.editor.unsupported': 'Unknown/Not recommended',
  'modelProvider.editor.visionNo': 'No/Unknown',
  'modelProvider.editor.recommendedTemp': 'Recommended temperature',
  'modelProvider.editor.recommendedMaxTokens': 'Recommended max_tokens',
  'modelProvider.editor.recommendedExtra': 'Recommended extra params',
  'modelProvider.editor.notes': 'Notes',
  'modelProvider.editor.paramSource': 'Param source',
  'modelProvider.editor.tuningEnabled': 'Enabled',
  'modelProvider.editor.tuningDisabled': 'Disabled',
  'modelProvider.editor.advancedTitle': 'Advanced Params (Model-Specific)',
  'modelProvider.editor.advancedDesc':
    'Parameters inferred from provider/model or model catalog metadata; saved to extra_params.',
  'modelProvider.editor.testProtocolLabel': 'Test Protocol',
  'modelProvider.editor.testNotSupported': 'Not Supported',
  'modelProvider.editor.authModeLabel': 'Auth Mode',
  'modelProvider.editor.authNone': 'No API Key needed',
  'modelProvider.editor.authOptional': 'Optional API Key',
  'modelProvider.editor.authRequired': 'API Key required',
  'modelProvider.editor.discovery': 'Auto Discovery',
  'modelProvider.editor.saved': 'Saved',
  'modelProvider.editor.testConnection': 'Test Connection',
  'modelProvider.editor.testTitle': 'Live connectivity test',
  'modelProvider.editor.testUnsupportedTitle':
    'Test protocol not supported (configure model in Global Model Config first)',
  'modelProvider.editor.testPassedCustom': 'Test passed, added to model catalog',
  'modelProvider.editor.testPassed': 'Test passed',
  'modelProvider.editor.save': 'Save',
  'modelProvider.editor.noTestHint':
    'Please configure model in Global Model Config first (current provider does not support test protocol)',

  'tooltip.baseUrl': 'Optional API Base URL',
  'tooltip.timeout': 'Request timeout in seconds',
  'tooltip.modelConcurrency': 'Max concurrent requests',
  'tooltip.vectorStoreProvider': 'Vector Database Provider',
  'tooltip.vectorStoreConnection': 'Connection parameters in JSON format',
  'tooltip.hybridVectorWeight': 'Weight for vector search in hybrid search',
  'tooltip.hybridKeywordWeight': 'Weight for keyword search in hybrid search',
  'tooltip.rerankTopK': 'Number of results after reranking',

  // Subscription
  'subscription.loadError': 'Failed to load subscription info',
  'subscription.currentPlan': 'Current Plan',
  'subscription.currentPlanBadge': 'Current Plan',
  'subscription.validUntil': 'Valid until {date}',
  'subscription.planName.free': 'Free',
  'subscription.planName.pro': 'Pro',
  'subscription.planName.max': 'Max',
  'subscription.monthly': 'Monthly',
  'subscription.yearly': 'Yearly',
  'subscription.yearlySave': 'Save 20%',
  'subscription.popular': 'Most Popular',
  'subscription.free': 'Free',
  'subscription.freePlan': 'Current Plan',
  'subscription.perMonth': 'mo',
  'subscription.perYear': 'yr',
  'subscription.billedYearly': 'Billed ¥{total}/year',
  'subscription.upgrade': 'Upgrade',
  'subscription.purchaseSuccess': 'Subscription activated!',
  'subscription.purchaseError': 'Purchase failed, please try again',
  'subscription.paymentPending': 'Order created, payment coming soon',
  'subscription.paymentExpired': 'This order is closed. Please create a new payment order.',
  'subscription.paymentStatusError': 'Failed to refresh payment status. Please try again.',
  'subscription.note':
    'Subscription will downgrade to Free after expiry. Payment integration coming soon.',
  'subscription.bestFor': 'Best For',
  'subscription.planSummary.free':
    'Best for first-time exploration, lightweight Q&A, and basic course trials',
  'subscription.planSummary.pro':
    'Best for daily lesson prep, office hours, and frequent teacher workflows',
  'subscription.planSummary.max':
    'Best for collaborative course design, long-context reasoning, and heavy usage',
  'subscription.compare.title': 'Plan Comparison',
  'subscription.compare.subtitle': 'Compare pricing, model access, and quotas at a glance.',
  'subscription.compare.metric': 'Metric',
  'subscription.compare.bestFor': 'Best For',
  'subscription.compare.monthlyPrice': 'Monthly Price',
  'subscription.compare.yearlyPrice': 'Yearly Price',
  'subscription.compare.modelAccess': 'Model Access',
  'subscription.compare.dailyMessages': 'Daily Messages',
  'subscription.compare.contextLength': 'Context Length',
  'subscription.compare.knowledgeBases': 'Knowledge Bases',
  'subscription.compare.fileSize': 'File Upload',
  'subscription.compare.deepThinking': 'Deep Thinking',
  'subscription.compare.priorityResponse': 'Priority Response',
  'subscription.compare.included': 'Included',
  'subscription.compare.notIncluded': 'Not included',
  'subscription.compare.unlimited': 'Unlimited',
  'subscription.features.basicModel': 'Basic model access',
  'subscription.features.modelsCount': '{count} premium models included',
  'subscription.features.allModels': 'All model access',
  'subscription.features.dailyMessages': '{count} messages per day',
  'subscription.features.unlimitedMessages': 'Unlimited messages',
  'subscription.features.contextLength': '{length} context length',
  'subscription.features.knowledgeBases': '{count} knowledge bases',
  'subscription.features.unlimitedKb': 'Unlimited knowledge bases',
  'subscription.features.fileSize': 'Up to {size}MB file upload',
  'subscription.features.deepThinking': 'Deep thinking mode',
  'subscription.features.priorityResponse': 'Priority response',
  'subscription.usage.title': "Today's Usage",
  'subscription.usage.messages': 'Messages {used}/{limit}',
  'subscription.usage.unlimited': '{used} messages (unlimited)',
  'subscription.usage.remaining': '{count} remaining',
  'subscription.usage.exhausted': 'Daily quota exhausted',
  'subscription.usage.upgrade': 'Upgrade Plan',

  'subscription.orders.title': 'Order History',
  'subscription.orders.empty': 'No orders yet',
  'subscription.orders.orderNo': 'Order No.',
  'subscription.orders.plan': 'Plan',
  'subscription.orders.amount': 'Amount',
  'subscription.orders.status': 'Status',
  'subscription.orders.date': 'Date',
  'subscription.orders.status.pending': 'Pending',
  'subscription.orders.status.paid': 'Paid',
  'subscription.orders.status.cancelled': 'Cancelled',
  'subscription.orders.status.expired': 'Expired',
  'subscription.annualSave': 'Save {pct}%',
  'subscription.paymentDialog.title': 'Payment Order',
  'subscription.paymentDialog.description':
    'Complete payment in a new tab or by scanning the QR code. This page will refresh the order status automatically.',
  'subscription.paymentDialog.orderNo': 'Order No.',
  'subscription.paymentDialog.amount': 'Amount',
  'subscription.paymentDialog.plan': 'Plan',
  'subscription.paymentDialog.status': 'Status',
  'subscription.paymentDialog.qrAlt': 'Payment QR code',
  'subscription.paymentDialog.noQr':
    'This order does not include a QR code yet. You can continue with the payment link below.',
  'subscription.paymentDialog.paymentLink': 'Payment Link',
  'subscription.paymentDialog.openPayment': 'Open Payment Page',
  'subscription.paymentDialog.copyLink': 'Copy Payment Link',
  'subscription.paymentDialog.copySuccess': 'Payment link copied',
  'subscription.paymentDialog.copyError': 'Failed to copy payment link',
  'subscription.paymentDialog.refresh': 'Refresh Status',
  'subscription.paymentDialog.pollHint':
    'The page will poll automatically after payment. You can also refresh manually.',

  // Quota exceeded
  // P0-B POLICY-2: non-upgrade wording when commerce surface is off
  'quota.dailyMessagesNoCommerce':
    'Daily message limit reached ({limit}/day). Please try again tomorrow.',
  'quota.modelAccessNoCommerce': 'Model {model} is not included in the current plan.',
  'quota.fileSizeNoCommerce': 'File size exceeds the current limit ({max}MB).',
  'quota.kbCountNoCommerce': 'Knowledge base limit reached ({max}).',
  'quota.contextLengthNoCommerce':
    'Context length exceeds the current limit ({max}). Please shorten the conversation.',
  'quota.featureNoCommerce': 'This feature is not included in the current plan.',
  'quota.genericExceededNoCommerce':
    'This action reached the current limit. Please adjust and try again.',
  'quota.dailyMessages':
    'Daily message limit reached ({limit}/day). Upgrade your plan or try again tomorrow.',
  'quota.dailyMessagesFallback':
    'Daily message limit reached. Upgrade your plan or try again tomorrow.',
  'quota.modelAccess': 'Model {model} is not available on your current plan. Please upgrade.',
  'quota.modelAccessFallback': 'This model is not available on your current plan. Please upgrade.',
  'quota.fileSize': 'File size exceeds your plan limit ({max}MB). Please upgrade.',
  'quota.fileSizeFallback': 'File size exceeds your plan limit. Please upgrade.',
  'quota.kbCount': 'Knowledge base limit reached ({max}). Please upgrade.',
  'quota.kbCountFallback': 'Knowledge base limit reached. Please upgrade.',
  'quota.contextLength':
    'Context length exceeds your plan limit ({max}). Please upgrade or shorten the conversation.',
  'quota.contextLengthFallback':
    'Context length exceeds your plan limit. Please upgrade or shorten the conversation.',
  'quota.feature': 'This feature is not available on your current plan. Please upgrade.',
  'quota.genericExceeded':
    'Your current plan limit has been reached. Please upgrade and try again.',

  // Dashboard i18n fix
  'admin.dashboard.autoRefresh': 'Auto',

  // Admin Bug Reports
  'admin.sidebar.bugReports': 'Bug Reports',
  'admin.bugs.title': 'Bug Reports',
  'admin.bugs.subtitle': 'Review and manage user-submitted bug reports',
  'admin.bugs.table.id': 'ID',
  'admin.bugs.table.title': 'Title',
  'admin.bugs.table.user': 'User',
  'admin.bugs.table.severity': 'Severity',
  'admin.bugs.table.status': 'Status',
  'admin.bugs.table.createdAt': 'Submitted',
  'admin.bugs.table.actions': 'Actions',
  'admin.bugs.status.open': 'Open',
  'admin.bugs.status.read': 'Read',
  'admin.bugs.status.in_progress': 'In Progress',
  'admin.bugs.status.resolved': 'Resolved',
  'admin.bugs.status.closed': 'Closed',
  'admin.bugs.severity.low': 'Low',
  'admin.bugs.severity.medium': 'Medium',
  'admin.bugs.severity.high': 'High',
  'admin.bugs.severity.critical': 'Critical',
  'admin.bugs.action.markRead': 'Mark Read',
  'admin.bugs.action.resolve': 'Resolve',
  'admin.bugs.action.updateNotes': 'Update Notes',
  'admin.bugs.action.viewDetail': 'View Details',
  'admin.bugs.action.saveNotes': 'Save Notes',
  'admin.bugs.filter.all': 'All',
  'admin.bugs.filter.unread': 'Unread',
  'admin.bugs.filter.status': 'Status',
  'admin.bugs.filter.severity': 'Severity',
  'admin.bugs.filter.search': 'Search bug reports...',
  'admin.bugs.filter.searchBtn': 'Search',
  'admin.bugs.empty': 'No bug reports yet',
  'admin.bugs.toast.markedRead': 'Marked as read',
  'admin.bugs.toast.resolved': 'Marked as resolved',
  'admin.bugs.toast.updateFailed': 'Update failed',
  'admin.bugs.toast.updated': 'Status updated',
  'admin.bugs.toast.notesSaved': 'Notes saved',
  'admin.bugs.detail.adminNotes': 'Admin Notes',
  'admin.bugs.detail.adminNotesPlaceholder': 'Add internal notes...',
  'admin.bugs.detail.status': 'Status',
  'admin.bugs.detail.severity': 'Severity',
  'admin.bugs.detail.description': 'Description',
  'admin.bugs.detail.steps': 'Steps to Reproduce',
  'admin.bugs.detail.screenshots': 'Screenshots',
  'admin.bugs.detail.submittedBy': 'Submitted By',
  'admin.bugs.detail.pageUrl': 'Page URL',
  'admin.bugs.detail.browserInfo': 'Browser Info',
  'admin.bugs.detail.browser': 'Browser',
  'admin.bugs.detail.changeStatus': 'Change Status',
  'admin.bugs.detail.user': 'User',
  'admin.bugs.detail.created': 'Created',
  'admin.bugs.detail.resolvedAt': 'Resolved At',
  'admin.bugs.detail.resolvedBy': 'Resolved By',
  'admin.bugs.detail.save': 'Save',
  'admin.bugs.unreadCount': '{count} unread',
  'admin.bugs.unread': 'unread',

  // Bug Feedback (user-facing settings tab)
  'settings.tabs.bugFeedback': 'Bug Feedback',
  'settings.tabs.bugFeedbackDesc': 'Submit and view bug reports',
  'bugFeedback.title': 'Bug Feedback',
  'bugFeedback.description': 'Submit bug reports to help us improve',
  'bugFeedback.field.title': 'Title',
  'bugFeedback.field.titlePlaceholder': 'Briefly describe the issue you encountered',
  'bugFeedback.field.description': 'Description',
  'bugFeedback.field.descriptionPlaceholder':
    'Describe the issue in detail, including expected vs actual behavior...',
  'bugFeedback.field.steps': 'Steps to Reproduce',
  'bugFeedback.field.stepsPlaceholder': '1. Open...\n2. Click...\n3. Error appears...',
  'bugFeedback.field.severity': 'Severity',
  'bugFeedback.field.screenshots': 'Screenshots (optional)',
  'bugFeedback.field.screenshotsHint': 'Drag or click to upload screenshots (max 5)',
  'bugFeedback.severity.low': 'Low — Minor issue',
  'bugFeedback.severity.medium': 'Medium — Feature impaired',
  'bugFeedback.severity.high': 'High — Core feature broken',
  'bugFeedback.severity.critical': 'Critical — System crash / Data loss',
  'bugFeedback.submit': 'Submit Report',
  'bugFeedback.submitting': 'Submitting...',
  'bugFeedback.submitted': 'Bug report submitted. Thank you for your feedback!',
  'bugFeedback.submitFailed': 'Submission failed, please try again',
  'bugFeedback.required': 'Title and description are required',
  'bugFeedback.myReports': 'My Reports',
  'bugFeedback.noReports': 'No reports yet',
  'bugFeedback.total': 'total',
  'bugFeedback.empty': 'No bug reports yet',
  'bugFeedback.screenshots.uploadFailed': 'Screenshot upload failed',
  'bugFeedback.screenshots.hint': 'Drag & drop or click to upload screenshots (max 5)',
  'bugFeedback.status.open': 'Open',
  'bugFeedback.status.read': 'Read',
  'bugFeedback.status.in_progress': 'In Progress',
  'bugFeedback.status.resolved': 'Resolved',
  'bugFeedback.status.closed': 'Closed',

  // Design migration batch 0: workbench runtime status (shared by the single
  // status chip and the unavailable card)
  'workbench.status.checking': 'Connecting to the workbench service…',
  'workbench.status.ready': 'Service ready',
  'workbench.status.unavailable': 'Service temporarily unavailable',
  'workbench.status.unavailableDetail': 'Could not reach the agent service. It may be a network hiccup or a restart — please retry.',
  'workbench.status.networkDetail': 'Network error while reaching the agent service. Check your connection and retry.',
  'workbench.status.disabled': 'Workbench not available',
  'workbench.status.disabledDetail': 'This workbench is not enabled in your environment yet. Contact your administrator or check back later.',
  'workbench.status.unauthorized': 'Sign-in expired',
  'workbench.status.unauthorizedDetail': 'Please sign in again to use this workbench.',
  'workbench.status.notFound': 'Service not deployed',
  'workbench.status.notFoundDetail': 'This workbench service does not exist in the current deployment; it may not be updated yet.',
  'workbench.status.retry': 'Retry',
  'workbench.status.rawDetailPrefix': 'Raw message',

  // Design migration batch 4: unified workbench shell (single status chip +
  // how-it-works collapse + back)
  'workbench.back': 'Back',
  'workbench.newSession': 'New session',
  'workbench.syncMode': 'Sync mode',
  'workbench.howItWorks': 'How it works',
  'workbench.handoffTitle': 'Continuation from main chat',
  'workbench.handoffIdentifiers': 'Task identifiers',

  // Design migration batch 5: workbench artifact rail actions
  'workbench.artifact.export': 'Export',
  'workbench.artifact.cite': 'Cite',

  'chat.modeGroup': 'Modes',

  'errorReview.settled': 'Answer submitted — this review step is complete.',};
